export const RENDER_EXTENSION_BASE_HEADER = `
<!DOCTYPE html>
<html
	lang="en"
	dir="ltr"
	class="
		no-js
		mac
		chrome
		desktop
		page--no-banner
		page--logo-main
		page--smaller-post-purchase-header
		page--post-purchase
		card-fields
	"
>
	<head>
		<meta charset="utf-8" />
		<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
		<meta
			name="viewport"
			content="width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, user-scalable=0"
		/>
		<meta name="referrer" content="origin" />
		<title>Post-purchase - Marlowe&#39;s Roastery - Checkout</title>
		<meta data-browser="chrome" data-browser-major="91" />
		<meta data-body-font-family="Roboto" data-body-font-type="google" />
		<!-- <link
			href="https://cdn.shopify.com/shopifycloud/checkout-web/assets/post-purchase.latest.en.2d0c3fc798f6119b756b.css"
			crossorigin="anonymous"
			rel="stylesheet"
		/> -->
		<style>
			@font-face {
				font-family: "Roboto";
				font-style: normal;
				font-weight: 400;
				src: local("Roboto Regular"), local("Roboto-Regular"),
					url(https://fonts.shopifycdn.com/roboto/roboto_n4.da808834c2315f31dd3910e2ae6b1a895d7f73f5.woff2?valid_until=MTYyNzUxMDE2NA&hmac=7cc6fa499a825d8acdbeaaff27052663b7a2d5b8c7fd7b2fe08dda19a58846a6)
						format("woff2"),
					url(https://fonts.shopifycdn.com/roboto/roboto_n4.a512c7b68cd7f12c72e1a5fd58e7f7315c552e93.woff?valid_until=MTYyNzUxMDE2NA&hmac=1760a3715ed520ccaf648eb5376584c6306fe49edc6b4c0ce6c34ec0f19e2866)
						format("woff");
			}
			@font-face {
				font-family: "Roboto";
				font-style: normal;
				font-weight: 500;
				src: local("Roboto Medium"), local("Roboto-Medium"),
					url(https://fonts.shopifycdn.com/roboto/roboto_n5.126dd24093e910b23578142c0183010eb1f2b9be.woff2?valid_until=MTYyNzUxMDE2NA&hmac=1cd2bc017e9fceb380560bfa298fae0487621afd64fa7a20cd98f84629d56b09)
						format("woff2"),
					url(https://fonts.shopifycdn.com/roboto/roboto_n5.ef0ac6b5ed77e19e95b9512154467a6fb9575078.woff?valid_until=MTYyNzUxMDE2NA&hmac=9900d45e67d624b9453fc7ccc32c132e7e4debc74c6b3ce3c77c23b5edf3df7a)
						format("woff");
			}
		</style>
		<style>
			:root {
				--color--light-grey: #bababa;
				--color--lightest-grey: #e6e6e6;
				--color--white: #fff;
				--x-color-canvas: #fff;
				--x-color-canvas-subdued: #fafafa;
				--x-color-canvas-text: #545454;
				--x-color-canvas-text-subdued: #737373;
				--x-color-canvas-text-emphasized: #333;
				--x-color-canvas-border: #d9d9d9;
				--x-color-canvas-border-emphasized: #949494;
				--x-color-surface-primary: #fff;
				--x-color-surface-primary-subdued: #fafafa;
				--x-color-surface-primary-text: #545454;
				--x-color-surface-primary-text-subdued: #737373;
				--x-color-surface-primary-text-emphasized: #333;
				--x-color-surface-primary-border: #d9d9d9;
				--x-color-surface-primary-border-emphasized: #949494;
				--x-color-surface-primary-disabled: #f8f8f8;
				--x-color-surface-primary-accent: #1879b9;
				--x-color-surface-secondary: #fafafa;
				--x-color-surface-secondary-subdued: #f5f5f5;
				--x-color-surface-secondary-text: #545454;
				--x-color-surface-secondary-text-subdued: #737373;
				--x-color-surface-secondary-text-emphasized: #333;
				--x-color-surface-secondary-border: #d9d9d9;
				--x-color-surface-secondary-border-emphasized: #949494;
				--x-color-surface-secondary-disabled: #f3f3f3;
				--x-color-surface-secondary-accent: #1879b9;
				--x-color-surface-tertiary: #fff;
				--x-color-surface-tertiary-subdued: #fafafa;
				--x-color-surface-tertiary-text: #545454;
				--x-color-surface-tertiary-text-subdued: #737373;
				--x-color-surface-tertiary-text-emphasized: #333;
				--x-color-surface-tertiary-border: #d9d9d9;
				--x-color-surface-tertiary-border-emphasized: #949494;
				--x-color-surface-tertiary-disabled: #f8f8f8;
				--x-color-surface-tertiary-accent: #1879b9;
				--x-color-primary-action: #1879b9;
				--x-color-primary-action-hovered: #115e92;
				--x-color-primary-action-pressed: #115e92;
				--x-color-primary-action-text: #fff;
				--x-color-primary-action-text-hovered: #fff;
				--x-color-primary-action-text-pressed: #fff;
				--x-color-secondary-action: #6b6b6b;
				--x-color-secondary-action-hovered: #525252;
				--x-color-secondary-action-pressed: #525252;
				--x-color-secondary-action-text: #fff;
				--x-color-secondary-action-text-hovered: #fff;
				--x-color-secondary-action-text-pressed: #fff;
				--x-color-tertiary-action: #ebebeb;
				--x-color-tertiary-action-text: #333;
				--x-color-tertiary-action-text-subdued: #666;
				--x-color-interactive: transparent;
				--x-color-interactive-hovered: transparent;
				--x-color-interactive-pressed: transparent;
				--x-color-interactive-text: #1879b9;
				--x-color-interactive-text-hovered: #1f93e0;
				--x-color-interactive-text-pressed: #1f93e0;
				--x-color-interactive-icon: #fff;
				--x-color-info: #f0f8ff;
				--x-color-info-disabled: #e0f5ff;
				--x-color-info-subdued: #e5f6ff;
				--x-color-info-text: #545454;
				--x-color-info-text-subdued: #737373;
				--x-color-info-text-emphasized: #333;
				--x-color-info-border: #d1e6f5;
				--x-color-info-border-emphasized: #003542;
				--x-color-info-accent: #1879b9;
				--x-color-success: #e8f8eb;
				--x-color-success-disabled: #d7f4dc;
				--x-color-success-subdued: #dbf5e1;
				--x-color-success-text: #545454;
				--x-color-success-text-subdued: #737373;
				--x-color-success-text-emphasized: #333;
				--x-color-success-border: #d0ecd3;
				--x-color-success-border-emphasized: #1c3121;
				--x-color-success-accent: #0ca127;
				--x-color-warning: #fff8e0;
				--x-color-warning-disabled: #fff2bd;
				--x-color-warning-subdued: #fff3c7;
				--x-color-warning-text: #545454;
				--x-color-warning-text-subdued: #737373;
				--x-color-warning-text-emphasized: #333;
				--x-color-warning-border: #f0e4bc;
				--x-color-warning-border-emphasized: #1c3121;
				--x-color-warning-accent: #b88700;
				--x-color-critical: #ffebeb;
				--x-color-critical-disabled: #ffe0e0;
				--x-color-critical-subdued: #ffe5e5;
				--x-color-critical-text: #545454;
				--x-color-critical-text-subdued: #737373;
				--x-color-critical-text-emphasized: #333;
				--x-color-critical-border: #facccc;
				--x-color-critical-border-emphasized: #5c0000;
				--x-color-critical-accent: #e22222;
				--x-typography-primary-fonts: -apple-system, BlinkMacSystemFont,
					"Segoe UI", Roboto, Helvetica, Arial, sans-serif,
					"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
					sans-serif;
				--x-typography-secondary-fonts: -apple-system,
					BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
					sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
					"Segoe UI Symbol", sans-serif;
				--x-typography-primary-weight-base: 400;
				--x-typography-primary-weight-bold: 500;
				--x-typography-secondary-weight-base: 400;
				--x-typography-secondary-weight-bold: 500;
				--x-typography-size-xsmall: 0.9rem;
				--x-typography-size-small: 1.2rem;
				--x-typography-size-default: 1.4rem;
				--x-typography-size-medium: 1.6rem;
				--x-typography-size-large: 1.8rem;
				--x-typography-size-xlarge: 2.4rem;
				--x-typography-size-xxlarge: 2.8rem;
				--x-spacing-tight4x: 0.5rem;
				--x-spacing-tight3x: 0.6rem;
				--x-spacing-tight2x: 0.7rem;
				--x-spacing-tight1x: 0.9rem;
				--x-spacing-tight: 1.1rem;
				--x-spacing-base: 1.4rem;
				--x-spacing-loose: 1.7rem;
				--x-spacing-loose1x: 2.1rem;
				--x-spacing-loose2x: 2.6rem;
				--x-spacing-loose3x: 3.2rem;
				--x-spacing-loose4x: 3.8rem;
				--x-duration-none: 0;
				--x-duration-fast: 100ms;
				--x-duration-base: 200ms;
				--x-duration-slow: 300ms;
				--x-duration-slower: 400ms;
				--x-duration-slowest: 500ms;
			}
			@media screen and (prefers-reduced-motion: reduce) {
				:root {
					--x-duration-fast: 0.001ms;
					--x-duration-base: 0.001ms;
					--x-duration-slow: 0.001ms;
					--x-duration-slower: 0.001ms;
					--x-duration-slowest: 0.001ms;
				}
			}
			:root {
				--x-timing-base: ease-in-out;
				--x-timing-ease-out: cubic-bezier(0.3, 0.5, 0.5, 1);
				--x-timing-linear: linear;
				--x-timing-spring: cubic-bezier(0.3, 0, 0, 1);
				--x-border-full: 1px;
				--x-border-block-end: 0 0 1px;
				--x-border-none: 0;
				--x-border-radius-none: 0;
				--x-border-radius-tight: 0.14285714285714285em;
				--x-border-radius-base: 0.35714285714285715em;
				--x-border-radius-fully-rounded: 1.6428571428571428em;
				--x-border-width-base: 1px;
				--x-border-width-thick: 0.14285714285714285em;
				--x-default-color-accent: #1879b9;
				--x-default-color-border: #d9d9d9;
				--x-default-color-border-emphasized: #949494;
				--x-global-typography-letter-case: none;
				--x-global-typography-line-size-default: 1.3;
				--x-global-typography-line-size-large: 1.5;
				--x-global-typography-kerning: normal;
				--x-global-border-radius: var(--x-border-radius-base);
				--x-control-border-radius: var(--x-border-radius-base);
				--x-text-field-border-radius: var(--x-border-radius-base);
				--x-checkbox-border-radius: var(--x-border-radius-base);
				--x-option-list-border-radius: var(--x-border-radius-base);
				--x-select-border-radius: var(--x-border-radius-base);
				--x-review-block-border-radius: var(--x-border-radius-base);
				--x-tag-border-radius: var(--x-border-radius-base);
				--x-option-list-block-gap: 0;
				--x-option-list-block-padding: var(--x-spacing-loose);
				--x-option-list-inline-padding: var(--x-spacing-loose);
				--x-money-lines-block-gap: var(--x-spacing-tight);
				--x-money-lines-separator-block-gap: var(--x-spacing-loose1x);
				--x-money-lines-block-padding: 0;
				--x-money-lines-inline-padding: 0;
				--x-money-summary-block-padding: 0;
				--x-money-summary-inline-padding: 0;
				--x-buyer-journey-inline-gap: var(--x-spacing-tight1x);
				--x-primary-button-block-padding: var(--x-spacing-loose1x);
				--x-primary-button-inline-padding: var(--x-spacing-loose2x);
				--x-secondary-button-block-padding: var(--x-spacing-loose1x);
				--x-secondary-button-inline-padding: var(--x-spacing-loose2x);
				--x-tertiary-button-block-padding: var(--x-spacing-tight4x);
				--x-tertiary-button-inline-padding: var(--x-spacing-tight3x);
				--x-radio-size-base: 1.2857142857142858em;
				--x-radio-size-large: 1.5714285714285714em;
				--x-checkbox-size: 1.2857142857142858em;
				--x-icon-size-small: 0.7142857142857143em;
				--x-icon-size-default: 1em;
				--x-icon-size-large: 1.2857142857142858em;
				--x-thumbnail-aspect-ratio: 1;
				--x-link-transition-duration: var(--x-duration-base);
			}
			*,
			:after,
			:before {
				box-sizing: border-box;
			}
			body,
			html {
				margin: 0;
				width: 100%;
				height: 100%;
			}
			html {
				font-size: 62.5%;
				text-size-adjust: 100%;
			}
			body {
				overflow-y: scroll;
				overflow-x: hidden;
				-webkit-font-smoothing: subpixel-antialiased;
				overflow-wrap: break-word;
			}
			p {
				margin: 0;
			}
			em,
			i {
				font-style: inherit;
			}
			b,
			strong {
				font-weight: inherit;
			}
			small {
				font-size: var(--x-typography-size-small);
			}
			address {
				font-style: normal;
			}
			table {
				border-collapse: collapse;
				border-spacing: 0;
			}
			td,
			th {
				padding: 0;
				font-weight: 400;
			}
			img {
				border-style: none;
			}
			figure {
				margin: 0;
			}
			fieldset {
				margin: 0;
			}
			fieldset,
			legend {
				padding: 0;
				border: 0;
			}
			button,
			input,
			optgroup,
			select,
			textarea {
				-webkit-appearance: none;
				appearance: none;
				border: 0;
				background: transparent;
				color: inherit;
				font: inherit;
				line-height: normal;
				margin: 0;
				padding: 0;
				-webkit-font-smoothing: inherit;
			}
			button,
			input {
				overflow: visible;
			}
			button,
			select {
				text-transform: none;
			}
			[type="button"],
			[type="reset"],
			[type="submit"],
			button {
				-webkit-appearance: button;
				appearance: button;
				cursor: pointer;
			}
			[type="checkbox"],
			[type="radio"] {
				padding: 0;
			}
			[hidden],
			template {
				display: none;
			}
			iframe {
				margin: 0;
				padding: 0;
				border: 0;
			}
			._1yitZ {
				position: relative;
				border-radius: var(
					--x-banner-border-radius,
					var(--x-global-border-radius)
				);
				border-width: var(--x-banner-border, var(--x-border-full));
				border-style: solid;
				padding: var(--x-spacing-loose);
			}
			._2mViu {
				margin: -0.25em 0;
				max-width: 1.7142857142857142em;
				max-height: 1.7142857142857142em;
			}
			._2z6Td {
				--x-default-color-border: var(--x-color-info-border);
				--x-default-color-border-emphasized: var(
					--x-color-info-border-emphasized
				);
				--x-default-color-text: var(--x-color-info-text);
				--x-default-color-text-subdued: var(
					--x-color-info-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-info-text-emphasized
				);
				color: var(--x-color-info-text);
				background-color: var(--x-color-info);
				border-color: var(--x-color-info-border);
			}
			._2z6Td ._2mViu {
				color: var(--x-color-info-accent);
			}
			._3wm7l {
				--x-default-color-border: var(--x-color-success-border);
				--x-default-color-border-emphasized: var(
					--x-color-success-border-emphasized
				);
				--x-default-color-text: var(--x-color-success-text);
				--x-default-color-text-subdued: var(
					--x-color-success-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-success-text-emphasized
				);
				color: var(--x-color-success-text);
				background-color: var(--x-color-success);
				border-color: var(--x-color-success-border);
			}
			._3wm7l ._2mViu {
				color: var(--x-color-success-accent);
			}
			.seqRC {
				--x-default-color-border: var(--x-color-warning-border);
				--x-default-color-border-emphasized: var(
					--x-color-warning-border-emphasized
				);
				--x-default-color-text: var(--x-color-warning-text);
				--x-default-color-text-subdued: var(
					--x-color-warning-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-warning-text-emphasized
				);
				color: var(--x-color-warning-text);
				background-color: var(--x-color-warning);
				border-color: var(--x-color-warning-border);
			}
			.seqRC ._2mViu {
				color: var(--x-color-warning-accent);
			}
			.GmMbc {
				--x-default-color-border: var(--x-color-critical-border);
				--x-default-color-border-emphasized: var(
					--x-color-critical-border-emphasized
				);
				--x-default-color-text: var(--x-color-critical-text);
				--x-default-color-text-subdued: var(
					--x-color-critical-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-critical-text-emphasized
				);
				color: var(--x-color-critical-text);
				background-color: var(--x-color-critical);
				border-color: var(--x-color-critical-border);
			}
			.GmMbc ._2mViu {
				color: var(--x-color-critical-accent);
			}
			.c2vii {
				-webkit-tap-highlight-color: transparent;
				padding: var(--x-spacing-tight);
				margin: calc(-1 * var(--x-spacing-tight));
				color: var(--banner-icon-color);
			}
			._2WN_- {
				display: flex;
			}
			[dir="ltr"] ._2WN_- > * {
				margin-left: var(--x-spacing-base);
			}
			._2WN_- > :dir(ltr) {
				margin-left: var(--x-spacing-base);
			}
			[dir="rtl"] ._2WN_- > * {
				margin-right: var(--x-spacing-base);
			}
			._2WN_- > :dir(rtl) {
				margin-right: var(--x-spacing-base);
			}
			._2WN_- > * {
				flex-grow: 1;
				margin-inline-start: var(--x-spacing-base);
			}
			[dir="ltr"] ._2WN_- > :first-child {
				margin-left: 0;
			}
			._2WN_- > :first-child:dir(ltr) {
				margin-left: 0;
			}
			[dir="rtl"] ._2WN_- > :first-child {
				margin-right: 0;
			}
			._2WN_- > :first-child:dir(rtl) {
				margin-right: 0;
			}
			._2WN_- > :first-child {
				margin-inline-start: 0;
			}
			.BhNx1 {
				align-items: flex-start;
			}
			._3KkOT {
				align-items: center;
			}
			._3nySG {
				align-items: flex-end;
			}
			._1TcGr {
				align-items: baseline;
			}
			[dir="ltr"] ._1ltuq > * {
				margin-left: var(--x-spacing-tight4x);
			}
			._1ltuq > :dir(ltr) {
				margin-left: var(--x-spacing-tight4x);
			}
			[dir="rtl"] ._1ltuq > * {
				margin-right: var(--x-spacing-tight4x);
			}
			._1ltuq > :dir(rtl) {
				margin-right: var(--x-spacing-tight4x);
			}
			._1ltuq > * {
				margin-inline-start: var(--x-spacing-tight4x);
			}
			[dir="ltr"] ._2l2b4 > * {
				margin-left: var(--x-spacing-tight1x);
			}
			._2l2b4 > :dir(ltr) {
				margin-left: var(--x-spacing-tight1x);
			}
			[dir="rtl"] ._2l2b4 > * {
				margin-right: var(--x-spacing-tight1x);
			}
			._2l2b4 > :dir(rtl) {
				margin-right: var(--x-spacing-tight1x);
			}
			._2l2b4 > * {
				margin-inline-start: var(--x-spacing-tight1x);
			}
			[dir="ltr"] ._1x8NG > * {
				margin-left: var(--x-spacing-loose1x);
			}
			._1x8NG > :dir(ltr) {
				margin-left: var(--x-spacing-loose1x);
			}
			[dir="rtl"] ._1x8NG > * {
				margin-right: var(--x-spacing-loose1x);
			}
			._1x8NG > :dir(rtl) {
				margin-right: var(--x-spacing-loose1x);
			}
			._1x8NG > * {
				margin-inline-start: var(--x-spacing-loose1x);
			}
			[dir="ltr"] ._2pa-4 > * {
				margin-left: var(--x-spacing-loose4x);
			}
			._2pa-4 > :dir(ltr) {
				margin-left: var(--x-spacing-loose4x);
			}
			[dir="rtl"] ._2pa-4 > * {
				margin-right: var(--x-spacing-loose4x);
			}
			._2pa-4 > :dir(rtl) {
				margin-right: var(--x-spacing-loose4x);
			}
			._2pa-4 > * {
				margin-inline-start: var(--x-spacing-loose4x);
			}
			._1NH3k > :last-child,
			.O9_XL > :first-child {
				flex-grow: 0;
				flex-shrink: 0;
			}
			._2b4G1 {
				display: block;
				max-height: 100%;
				max-width: 100%;
				fill: currentColor;
			}
			._1DCeN {
				width: var(--x-icon-size-default);
				height: var(--x-icon-size-default);
			}
			._17V3Z {
				width: var(--x-icon-size-small);
				height: var(--x-icon-size-small);
			}
			._1th4u {
				width: var(--x-icon-size-large);
				height: var(--x-icon-size-large);
			}
			._3xEAK {
				color: var(--x-default-color-accent);
			}
			._1k7OC {
				color: var(--x-color-interactive-text);
			}
			._3TkaF {
				color: var(
					--x-default-color-text-subdued,
					var(--x-default-color-text, inherit)
				);
			}
			._3PCbK {
				color: var(--x-color-info-accent);
			}
			._3ZdlP {
				color: var(--x-color-success-accent);
			}
			.HXOtr {
				color: var(--x-color-critical-accent);
			}
			._2Gv6l {
				color: var(--x-color-warning-accent);
			}
			._3ctsg,
			.alezA {
				position: relative;
				display: block;
				width: 100%;
				max-width: 100%;
				max-height: 100%;
			}
			._2TLZ3 {
				padding-bottom: 100%;
			}
			._2U5PX > * + * {
				margin-top: var(--x-spacing-base);
			}
			._21Ec2 > * + * {
				margin-top: 0;
			}
			.qG4ms > * + * {
				margin-top: var(--x-spacing-tight2x);
			}
			._1PIy3 > * + * {
				margin-top: var(--x-spacing-loose2x);
			}
			[dir="ltr"] ._2d7W7 {
				text-align: left;
			}
			._2d7W7:dir(ltr) {
				text-align: left;
			}
			[dir="rtl"] ._2d7W7 {
				text-align: right;
			}
			._2d7W7:dir(rtl) {
				text-align: right;
			}
			._2d7W7 {
				text-align: start;
			}
			.lPIRt {
				text-align: center;
			}
			[dir="ltr"] ._30hoE {
				text-align: right;
			}
			._30hoE:dir(ltr) {
				text-align: right;
			}
			[dir="rtl"] ._30hoE {
				text-align: left;
			}
			._30hoE:dir(rtl) {
				text-align: left;
			}
			._30hoE {
				text-align: end;
			}
			[class]._1_W5e::placeholder,
			[class]._2dL8x {
				font-size: var(
					--x-style1-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style1-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style1-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style1-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style1-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style1-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._21_X5,
			[class].megBe::placeholder {
				font-size: var(
					--x-style2-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style2-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style2-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style2-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style2-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style2-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._3HbAs::placeholder,
			[class].Sqr7e {
				font-size: var(
					--x-style3-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style3-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style3-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style3-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style3-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style3-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._1ILlH,
			[class]._50vkb::placeholder {
				font-size: var(
					--x-style4-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style4-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style4-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style4-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style4-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style4-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._1fCMB::placeholder,
			[class]._1l9El {
				font-size: var(
					--x-style5-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style5-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style5-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style5-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style5-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style5-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._2hMGQ::placeholder,
			[class].OiYEn {
				font-size: var(
					--x-style6-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style6-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style6-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style6-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style6-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style6-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._1xW6T,
			[class]._3dQmx::placeholder {
				font-size: var(
					--x-style7-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style7-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style7-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style7-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style7-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style7-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._3bbPW::placeholder,
			[class]._89w7k {
				font-size: var(
					--x-style8-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style8-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style8-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style8-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style8-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style8-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			[class]._1ZQ8C::placeholder,
			[class]._2rCTQ {
				font-size: var(
					--x-style9-typography-size,
					var(--this-font-size)
				);
				text-transform: var(
					--x-style9-typography-case,
					var(--this-text-transform)
				);
				font-family: var(
					--x-style9-typography-fonts,
					var(--this-font-family)
				);
				font-weight: var(
					--x-style9-typography-weight,
					var(--this-font-weight)
				);
				line-height: var(
					--x-style9-typography-line-size,
					var(--this-line-height)
				);
				letter-spacing: var(
					--x-style9-typography-kerning,
					var(--this-letter-spacing)
				);
			}
			.YkjCf {
				--this-font-family: var(--x-typography-secondary-fonts);
				--this-line-height: var(
					--x-global-typography-line-size-default
				);
				color: inherit;
				margin: 0;
				font-family: var(--this-font-family);
				line-height: var(--this-line-height);
				text-transform: var(--x-global-typography-letter-case);
				letter-spacing: var(--x-global-typography-kerning);
			}
			._3UrqZ {
				--this-font-size: var(--x-typography-size-xxlarge);
			}
			._3UrqZ,
			.m3RQR {
				--this-font-weight: var(--x-typography-secondary-weight-base);
				font-size: var(--this-font-size);
				font-weight: var(--this-font-weight);
			}
			.m3RQR {
				--this-font-size: var(--x-typography-size-large);
			}
			._2vw3X,
			.m3RQR {
				color: var(
					--x-default-color-text-emphasized,
					var(--x-default-color-text, inherit)
				);
			}
			._2vw3X {
				--this-font-size: var(--x-typography-size-default);
				--this-font-weight: var(--x-typography-secondary-weight-bold);
				font-size: var(--this-font-size);
				font-weight: var(--this-font-weight);
			}
			[dir="ltr"] ._2bFYk {
				padding-left: var(--x-spacing-tight4x);
			}
			._2bFYk:dir(ltr) {
				padding-left: var(--x-spacing-tight4x);
			}
			[dir="rtl"] ._2bFYk {
				padding-right: var(--x-spacing-tight4x);
			}
			._2bFYk:dir(rtl) {
				padding-right: var(--x-spacing-tight4x);
			}
			._2bFYk {
				padding-inline-start: var(--x-spacing-tight4x);
			}
			[dir="ltr"] ._1XHN7 {
				padding-left: var(--x-spacing-tight1x);
			}
			._1XHN7:dir(ltr) {
				padding-left: var(--x-spacing-tight1x);
			}
			[dir="rtl"] ._1XHN7 {
				padding-right: var(--x-spacing-tight1x);
			}
			._1XHN7:dir(rtl) {
				padding-right: var(--x-spacing-tight1x);
			}
			._1XHN7 {
				padding-inline-start: var(--x-spacing-tight1x);
			}
			[dir="ltr"] ._20tpS {
				padding-left: var(--x-spacing-base);
			}
			._20tpS:dir(ltr) {
				padding-left: var(--x-spacing-base);
			}
			[dir="rtl"] ._20tpS {
				padding-right: var(--x-spacing-base);
			}
			._20tpS:dir(rtl) {
				padding-right: var(--x-spacing-base);
			}
			._20tpS {
				padding-inline-start: var(--x-spacing-base);
			}
			[dir="ltr"] ._3yHvW {
				padding-left: var(--x-spacing-loose1x);
			}
			._3yHvW:dir(ltr) {
				padding-left: var(--x-spacing-loose1x);
			}
			[dir="rtl"] ._3yHvW {
				padding-right: var(--x-spacing-loose1x);
			}
			._3yHvW:dir(rtl) {
				padding-right: var(--x-spacing-loose1x);
			}
			._3yHvW {
				padding-inline-start: var(--x-spacing-loose1x);
			}
			[dir="ltr"] ._2chQv {
				padding-left: var(--x-spacing-loose4x);
			}
			._2chQv:dir(ltr) {
				padding-left: var(--x-spacing-loose4x);
			}
			[dir="rtl"] ._2chQv {
				padding-right: var(--x-spacing-loose4x);
			}
			._2chQv:dir(rtl) {
				padding-right: var(--x-spacing-loose4x);
			}
			._2chQv {
				padding-inline-start: var(--x-spacing-loose4x);
			}
			[dir="ltr"] ._14usK {
				padding-right: var(--x-spacing-tight4x);
			}
			._14usK:dir(ltr) {
				padding-right: var(--x-spacing-tight4x);
			}
			[dir="rtl"] ._14usK {
				padding-left: var(--x-spacing-tight4x);
			}
			._14usK:dir(rtl) {
				padding-left: var(--x-spacing-tight4x);
			}
			._14usK {
				padding-inline-end: var(--x-spacing-tight4x);
			}
			[dir="ltr"] ._1Cz79 {
				padding-right: var(--x-spacing-tight1x);
			}
			._1Cz79:dir(ltr) {
				padding-right: var(--x-spacing-tight1x);
			}
			[dir="rtl"] ._1Cz79 {
				padding-left: var(--x-spacing-tight1x);
			}
			._1Cz79:dir(rtl) {
				padding-left: var(--x-spacing-tight1x);
			}
			._1Cz79 {
				padding-inline-end: var(--x-spacing-tight1x);
			}
			[dir="ltr"] ._1GPjx {
				padding-right: var(--x-spacing-base);
			}
			._1GPjx:dir(ltr) {
				padding-right: var(--x-spacing-base);
			}
			[dir="rtl"] ._1GPjx {
				padding-left: var(--x-spacing-base);
			}
			._1GPjx:dir(rtl) {
				padding-left: var(--x-spacing-base);
			}
			._1GPjx {
				padding-inline-end: var(--x-spacing-base);
			}
			[dir="ltr"] ._7avLT {
				padding-right: var(--x-spacing-loose1x);
			}
			._7avLT:dir(ltr) {
				padding-right: var(--x-spacing-loose1x);
			}
			[dir="rtl"] ._7avLT {
				padding-left: var(--x-spacing-loose1x);
			}
			._7avLT:dir(rtl) {
				padding-left: var(--x-spacing-loose1x);
			}
			._7avLT {
				padding-inline-end: var(--x-spacing-loose1x);
			}
			[dir="ltr"] ._3Eab3 {
				padding-right: var(--x-spacing-loose4x);
			}
			._3Eab3:dir(ltr) {
				padding-right: var(--x-spacing-loose4x);
			}
			[dir="rtl"] ._3Eab3 {
				padding-left: var(--x-spacing-loose4x);
			}
			._3Eab3:dir(rtl) {
				padding-left: var(--x-spacing-loose4x);
			}
			._3Eab3 {
				padding-inline-end: var(--x-spacing-loose4x);
			}
			._3lrTm {
				padding-top: var(--x-spacing-tight4x);
			}
			._1d7ON {
				padding-top: var(--x-spacing-tight1x);
			}
			._21M_G {
				padding-top: var(--x-spacing-base);
			}
			._1Os5W {
				padding-top: var(--x-spacing-loose1x);
			}
			._3E2hf {
				padding-top: var(--x-spacing-loose4x);
			}
			._1RZUN {
				padding-bottom: var(--x-spacing-tight4x);
			}
			._3HzFl {
				padding-bottom: var(--x-spacing-tight1x);
			}
			._1PNJd {
				padding-bottom: var(--x-spacing-base);
			}
			._3R4vM {
				padding-bottom: var(--x-spacing-loose1x);
			}
			._3qpnm {
				padding-bottom: var(--x-spacing-loose4x);
			}
			._2ceWP {
				--x-default-color-subdued: var(
					--x-color-surface-primary-subdued
				);
				--x-default-color-text: var(--x-color-surface-primary-text);
				--x-default-color-text-subdued: var(
					--x-color-surface-primary-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-surface-primary-text-emphasized
				);
				--x-default-color-border: var(--x-color-surface-primary-border);
				--x-default-color-border-emphasized: var(
					--x-color-surface-primary-border-emphasized
				);
				--x-default-color-accent: var(--x-color-surface-primary-accent);
				background-color: var(--x-color-surface-primary);
			}
			._2ceWP,
			._37nm0 {
				color: var(--x-default-color-text);
			}
			._37nm0 {
				--x-default-color-subdued: var(
					--x-color-surface-secondary-subdued
				);
				--x-default-color-text: var(--x-color-surface-secondary-text);
				--x-default-color-text-subdued: var(
					--x-color-surface-secondary-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-surface-secondary-text-emphasized
				);
				--x-default-color-border: var(
					--x-color-surface-secondary-border
				);
				--x-default-color-border-emphasized: var(
					--x-color-surface-secondary-border-emphasized
				);
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
				background-color: var(--x-color-surface-secondary);
			}
			._2Wtvv {
				--x-default-color-subdued: var(
					--x-color-surface-tertiary-subdued
				);
				--x-default-color-text: var(--x-color-surface-tertiary-text);
				--x-default-color-text-subdued: var(
					--x-color-surface-tertiary-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-surface-tertiary-text-emphasized
				);
				--x-default-color-border: var(
					--x-color-surface-tertiary-border
				);
				--x-default-color-border-emphasized: var(
					--x-color-surface-tertiary-border-emphasized
				);
				--x-default-color-accent: var(
					--x-color-surface-tertiary-accent
				);
				background-color: var(--x-color-surface-tertiary);
				color: var(--x-default-color-text);
			}
			[dir="ltr"] ._1lus2 {
				border-left: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._1lus2:dir(ltr) {
				border-left: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			[dir="rtl"] ._1lus2 {
				border-right: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._1lus2:dir(rtl) {
				border-right: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._1lus2 {
				border-inline-start: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			[dir="ltr"] ._1YOR8 {
				border-left: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._1YOR8:dir(ltr) {
				border-left: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			[dir="rtl"] ._1YOR8 {
				border-right: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._1YOR8:dir(rtl) {
				border-right: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._1YOR8 {
				border-inline-start: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			[dir="ltr"] ._28W8f {
				border-right: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._28W8f:dir(ltr) {
				border-right: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			[dir="rtl"] ._28W8f {
				border-left: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._28W8f:dir(rtl) {
				border-left: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._28W8f {
				border-inline-end: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			[dir="ltr"] ._2PCHK {
				border-right: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._2PCHK:dir(ltr) {
				border-right: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			[dir="rtl"] ._2PCHK {
				border-left: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._2PCHK:dir(rtl) {
				border-left: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._2PCHK {
				border-inline-end: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			.wjs4P {
				border-top: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._1Kg9X {
				border-top: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			._1KAuN {
				border-bottom: var(--x-border-width-base) solid
					var(--x-default-color-border);
			}
			._24KLU {
				border-bottom: var(--x-border-width-base) dotted
					var(--x-default-color-border);
			}
			[dir="ltr"] ._3fcbj {
				border-left-width: var(--x-border-width-base);
			}
			._3fcbj:dir(ltr) {
				border-left-width: var(--x-border-width-base);
			}
			[dir="rtl"] ._3fcbj {
				border-right-width: var(--x-border-width-base);
			}
			._3fcbj:dir(rtl) {
				border-right-width: var(--x-border-width-base);
			}
			._3fcbj {
				border-inline-start-width: var(--x-border-width-base);
			}
			[dir="ltr"] ._3T91Y {
				border-left-width: var(--x-border-width-thick);
			}
			._3T91Y:dir(ltr) {
				border-left-width: var(--x-border-width-thick);
			}
			[dir="rtl"] ._3T91Y {
				border-right-width: var(--x-border-width-thick);
			}
			._3T91Y:dir(rtl) {
				border-right-width: var(--x-border-width-thick);
			}
			._3T91Y {
				border-inline-start-width: var(--x-border-width-thick);
			}
			[dir="ltr"] ._3UMPD {
				border-right-width: var(--x-border-width-base);
			}
			._3UMPD:dir(ltr) {
				border-right-width: var(--x-border-width-base);
			}
			[dir="rtl"] ._3UMPD {
				border-left-width: var(--x-border-width-base);
			}
			._3UMPD:dir(rtl) {
				border-left-width: var(--x-border-width-base);
			}
			._3UMPD {
				border-inline-end-width: var(--x-border-width-base);
			}
			[dir="ltr"] ._3Cel0 {
				border-right-width: var(--x-border-width-thick);
			}
			._3Cel0:dir(ltr) {
				border-right-width: var(--x-border-width-thick);
			}
			[dir="rtl"] ._3Cel0 {
				border-left-width: var(--x-border-width-thick);
			}
			._3Cel0:dir(rtl) {
				border-left-width: var(--x-border-width-thick);
			}
			._3Cel0 {
				border-inline-end-width: var(--x-border-width-thick);
			}
			.mkcch {
				border-top-width: var(--x-border-width-base);
			}
			._3C9o2 {
				border-top-width: var(--x-border-width-thick);
			}
			._2YPEs {
				border-bottom-width: var(--x-border-width-base);
			}
			._23ElV {
				border-bottom-width: var(--x-border-width-thick);
			}
			[dir="ltr"] .pl_p8 {
				border-left-color: var(--x-default-color-border);
			}
			.pl_p8:dir(ltr) {
				border-left-color: var(--x-default-color-border);
			}
			[dir="rtl"] .pl_p8 {
				border-right-color: var(--x-default-color-border);
			}
			.pl_p8:dir(rtl) {
				border-right-color: var(--x-default-color-border);
			}
			.pl_p8 {
				border-inline-start-color: var(--x-default-color-border);
			}
			[dir="ltr"] ._35Pg6 {
				border-left-color: var(--x-default-color-border-emphasized);
			}
			._35Pg6:dir(ltr) {
				border-left-color: var(--x-default-color-border-emphasized);
			}
			[dir="rtl"] ._35Pg6 {
				border-right-color: var(--x-default-color-border-emphasized);
			}
			._35Pg6:dir(rtl) {
				border-right-color: var(--x-default-color-border-emphasized);
			}
			._35Pg6 {
				border-inline-start-color: var(
					--x-default-color-border-emphasized
				);
			}
			[dir="ltr"] ._3FjRK {
				border-right-color: var(--x-default-color-border);
			}
			._3FjRK:dir(ltr) {
				border-right-color: var(--x-default-color-border);
			}
			[dir="rtl"] ._3FjRK {
				border-left-color: var(--x-default-color-border);
			}
			._3FjRK:dir(rtl) {
				border-left-color: var(--x-default-color-border);
			}
			._3FjRK {
				border-inline-end-color: var(--x-default-color-border);
			}
			[dir="ltr"] ._2MSXA {
				border-right-color: var(--x-default-color-border-emphasized);
			}
			._2MSXA:dir(ltr) {
				border-right-color: var(--x-default-color-border-emphasized);
			}
			[dir="rtl"] ._2MSXA {
				border-left-color: var(--x-default-color-border-emphasized);
			}
			._2MSXA:dir(rtl) {
				border-left-color: var(--x-default-color-border-emphasized);
			}
			._2MSXA {
				border-inline-end-color: var(
					--x-default-color-border-emphasized
				);
			}
			.swVR3 {
				border-top-color: var(--x-default-color-border);
			}
			._2JYlv {
				border-top-color: var(--x-default-color-border-emphasized);
			}
			._38Ev3 {
				border-bottom-color: var(--x-default-color-border);
			}
			.waRM1 {
				border-bottom-color: var(--x-default-color-border-emphasized);
			}
			[dir="ltr"] .jjK6k {
				border-top-left-radius: var(--x-border-radius-tight);
			}
			.jjK6k:dir(ltr) {
				border-top-left-radius: var(--x-border-radius-tight);
			}
			[dir="rtl"] .jjK6k {
				border-top-right-radius: var(--x-border-radius-tight);
			}
			.jjK6k:dir(rtl) {
				border-top-right-radius: var(--x-border-radius-tight);
			}
			.jjK6k {
				border-start-start-radius: var(--x-border-radius-tight);
			}
			[dir="ltr"] ._387xm {
				border-top-left-radius: var(--x-border-radius-base);
			}
			._387xm:dir(ltr) {
				border-top-left-radius: var(--x-border-radius-base);
			}
			[dir="rtl"] ._387xm {
				border-top-right-radius: var(--x-border-radius-base);
			}
			._387xm:dir(rtl) {
				border-top-right-radius: var(--x-border-radius-base);
			}
			._387xm {
				border-start-start-radius: var(--x-border-radius-base);
			}
			[dir="ltr"] ._2DqnQ {
				border-bottom-left-radius: var(--x-border-radius-tight);
			}
			._2DqnQ:dir(ltr) {
				border-bottom-left-radius: var(--x-border-radius-tight);
			}
			[dir="rtl"] ._2DqnQ {
				border-bottom-right-radius: var(--x-border-radius-tight);
			}
			._2DqnQ:dir(rtl) {
				border-bottom-right-radius: var(--x-border-radius-tight);
			}
			._2DqnQ {
				border-end-start-radius: var(--x-border-radius-tight);
			}
			[dir="ltr"] ._3Xh8a {
				border-bottom-left-radius: var(--x-border-radius-base);
			}
			._3Xh8a:dir(ltr) {
				border-bottom-left-radius: var(--x-border-radius-base);
			}
			[dir="rtl"] ._3Xh8a {
				border-bottom-right-radius: var(--x-border-radius-base);
			}
			._3Xh8a:dir(rtl) {
				border-bottom-right-radius: var(--x-border-radius-base);
			}
			._3Xh8a {
				border-end-start-radius: var(--x-border-radius-base);
			}
			[dir="ltr"] .ncfxJ {
				border-top-right-radius: var(--x-border-radius-tight);
			}
			.ncfxJ:dir(ltr) {
				border-top-right-radius: var(--x-border-radius-tight);
			}
			[dir="rtl"] .ncfxJ {
				border-top-left-radius: var(--x-border-radius-tight);
			}
			.ncfxJ:dir(rtl) {
				border-top-left-radius: var(--x-border-radius-tight);
			}
			.ncfxJ {
				border-start-end-radius: var(--x-border-radius-tight);
			}
			[dir="ltr"] ._2A9da {
				border-top-right-radius: var(--x-border-radius-base);
			}
			._2A9da:dir(ltr) {
				border-top-right-radius: var(--x-border-radius-base);
			}
			[dir="rtl"] ._2A9da {
				border-top-left-radius: var(--x-border-radius-base);
			}
			._2A9da:dir(rtl) {
				border-top-left-radius: var(--x-border-radius-base);
			}
			._2A9da {
				border-start-end-radius: var(--x-border-radius-base);
			}
			[dir="ltr"] ._1vxho {
				border-bottom-right-radius: var(--x-border-radius-tight);
			}
			._1vxho:dir(ltr) {
				border-bottom-right-radius: var(--x-border-radius-tight);
			}
			[dir="rtl"] ._1vxho {
				border-bottom-left-radius: var(--x-border-radius-tight);
			}
			._1vxho:dir(rtl) {
				border-bottom-left-radius: var(--x-border-radius-tight);
			}
			._1vxho {
				border-end-end-radius: var(--x-border-radius-tight);
			}
			[dir="ltr"] .K-4sB {
				border-bottom-right-radius: var(--x-border-radius-base);
			}
			.K-4sB:dir(ltr) {
				border-bottom-right-radius: var(--x-border-radius-base);
			}
			[dir="rtl"] .K-4sB {
				border-bottom-left-radius: var(--x-border-radius-base);
			}
			.K-4sB:dir(rtl) {
				border-bottom-left-radius: var(--x-border-radius-base);
			}
			.K-4sB {
				border-end-end-radius: var(--x-border-radius-base);
			}
			@media screen and (min-width: 750px) {
				[dir="ltr"] .jd8-w {
					padding-left: var(--x-spacing-tight4x);
				}
				.jd8-w:dir(ltr) {
					padding-left: var(--x-spacing-tight4x);
				}
				[dir="rtl"] .jd8-w {
					padding-right: var(--x-spacing-tight4x);
				}
				.jd8-w:dir(rtl) {
					padding-right: var(--x-spacing-tight4x);
				}
				.jd8-w {
					padding-inline-start: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._3Unoh {
					padding-left: var(--x-spacing-tight1x);
				}
				._3Unoh:dir(ltr) {
					padding-left: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._3Unoh {
					padding-right: var(--x-spacing-tight1x);
				}
				._3Unoh:dir(rtl) {
					padding-right: var(--x-spacing-tight1x);
				}
				._3Unoh {
					padding-inline-start: var(--x-spacing-tight1x);
				}
				[dir="ltr"] ._3pB-s {
					padding-left: var(--x-spacing-base);
				}
				._3pB-s:dir(ltr) {
					padding-left: var(--x-spacing-base);
				}
				[dir="rtl"] ._3pB-s {
					padding-right: var(--x-spacing-base);
				}
				._3pB-s:dir(rtl) {
					padding-right: var(--x-spacing-base);
				}
				._3pB-s {
					padding-inline-start: var(--x-spacing-base);
				}
				[dir="ltr"] ._1Hfno {
					padding-left: var(--x-spacing-loose1x);
				}
				._1Hfno:dir(ltr) {
					padding-left: var(--x-spacing-loose1x);
				}
				[dir="rtl"] ._1Hfno {
					padding-right: var(--x-spacing-loose1x);
				}
				._1Hfno:dir(rtl) {
					padding-right: var(--x-spacing-loose1x);
				}
				._1Hfno {
					padding-inline-start: var(--x-spacing-loose1x);
				}
				[dir="ltr"] ._2YvPA {
					padding-left: var(--x-spacing-loose4x);
				}
				._2YvPA:dir(ltr) {
					padding-left: var(--x-spacing-loose4x);
				}
				[dir="rtl"] ._2YvPA {
					padding-right: var(--x-spacing-loose4x);
				}
				._2YvPA:dir(rtl) {
					padding-right: var(--x-spacing-loose4x);
				}
				._2YvPA {
					padding-inline-start: var(--x-spacing-loose4x);
				}
				[dir="ltr"] ._2YYQ3 {
					padding-left: 0;
				}
				._2YYQ3:dir(ltr) {
					padding-left: 0;
				}
				[dir="rtl"] ._2YYQ3 {
					padding-right: 0;
				}
				._2YYQ3:dir(rtl) {
					padding-right: 0;
				}
				._2YYQ3 {
					padding-inline-start: 0;
				}
				[dir="ltr"] ._1SB71 {
					padding-right: var(--x-spacing-tight4x);
				}
				._1SB71:dir(ltr) {
					padding-right: var(--x-spacing-tight4x);
				}
				[dir="rtl"] ._1SB71 {
					padding-left: var(--x-spacing-tight4x);
				}
				._1SB71:dir(rtl) {
					padding-left: var(--x-spacing-tight4x);
				}
				._1SB71 {
					padding-inline-end: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._1F1In {
					padding-right: var(--x-spacing-tight1x);
				}
				._1F1In:dir(ltr) {
					padding-right: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._1F1In {
					padding-left: var(--x-spacing-tight1x);
				}
				._1F1In:dir(rtl) {
					padding-left: var(--x-spacing-tight1x);
				}
				._1F1In {
					padding-inline-end: var(--x-spacing-tight1x);
				}
				[dir="ltr"] .EuaHr {
					padding-right: var(--x-spacing-base);
				}
				.EuaHr:dir(ltr) {
					padding-right: var(--x-spacing-base);
				}
				[dir="rtl"] .EuaHr {
					padding-left: var(--x-spacing-base);
				}
				.EuaHr:dir(rtl) {
					padding-left: var(--x-spacing-base);
				}
				.EuaHr {
					padding-inline-end: var(--x-spacing-base);
				}
				[dir="ltr"] ._2-FFj {
					padding-right: var(--x-spacing-loose1x);
				}
				._2-FFj:dir(ltr) {
					padding-right: var(--x-spacing-loose1x);
				}
				[dir="rtl"] ._2-FFj {
					padding-left: var(--x-spacing-loose1x);
				}
				._2-FFj:dir(rtl) {
					padding-left: var(--x-spacing-loose1x);
				}
				._2-FFj {
					padding-inline-end: var(--x-spacing-loose1x);
				}
				[dir="ltr"] ._3a5_h {
					padding-right: var(--x-spacing-loose4x);
				}
				._3a5_h:dir(ltr) {
					padding-right: var(--x-spacing-loose4x);
				}
				[dir="rtl"] ._3a5_h {
					padding-left: var(--x-spacing-loose4x);
				}
				._3a5_h:dir(rtl) {
					padding-left: var(--x-spacing-loose4x);
				}
				._3a5_h {
					padding-inline-end: var(--x-spacing-loose4x);
				}
				[dir="ltr"] ._2bft_ {
					padding-right: 0;
				}
				._2bft_:dir(ltr) {
					padding-right: 0;
				}
				[dir="rtl"] ._2bft_ {
					padding-left: 0;
				}
				._2bft_:dir(rtl) {
					padding-left: 0;
				}
				._2bft_ {
					padding-inline-end: 0;
				}
				._1XpfR {
					padding-top: var(--x-spacing-tight4x);
				}
				.NlRea {
					padding-top: var(--x-spacing-tight1x);
				}
				._1LQmw {
					padding-top: var(--x-spacing-base);
				}
				._3qSxF {
					padding-top: var(--x-spacing-loose1x);
				}
				._14lfB {
					padding-top: var(--x-spacing-loose4x);
				}
				._1b-0e {
					padding-top: 0;
				}
				.p45Z5 {
					padding-bottom: var(--x-spacing-tight4x);
				}
				._1xLoj {
					padding-bottom: var(--x-spacing-tight1x);
				}
				._1Pdjm {
					padding-bottom: var(--x-spacing-base);
				}
				._3WBCQ {
					padding-bottom: var(--x-spacing-loose1x);
				}
				._1g9qW {
					padding-bottom: var(--x-spacing-loose4x);
				}
				.edXer {
					padding-bottom: 0;
				}
				._1FX7C {
					--x-default-color-subdued: var(
						--x-color-surface-primary-subdued
					);
					--x-default-color-text: var(--x-color-surface-primary-text);
					--x-default-color-text-subdued: var(
						--x-color-surface-primary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-primary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-primary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-primary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-primary-accent
					);
					background-color: var(--x-color-surface-primary);
				}
				._1FX7C,
				._2ZWST {
					color: var(--x-default-color-text);
				}
				._2ZWST {
					--x-default-color-subdued: var(
						--x-color-surface-secondary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-secondary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-secondary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-secondary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-secondary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-secondary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-secondary-accent
					);
					background-color: var(--x-color-surface-secondary);
				}
				._1TYSr {
					--x-default-color-subdued: var(
						--x-color-surface-tertiary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-tertiary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-tertiary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-tertiary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-tertiary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-tertiary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-tertiary-accent
					);
					background-color: var(--x-color-surface-tertiary);
					color: var(--x-default-color-text);
				}
				._3bcLE {
					background-color: transparent;
				}
				[dir="ltr"] ._2TYgn {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._2TYgn:dir(ltr) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] ._2TYgn {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._2TYgn:dir(rtl) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._2TYgn {
					border-inline-start: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] ._1mU9K {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._1mU9K:dir(ltr) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] ._1mU9K {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._1mU9K:dir(rtl) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._1mU9K {
					border-inline-start: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] ._2hwGz {
					border-left: 0;
				}
				._2hwGz:dir(ltr) {
					border-left: 0;
				}
				[dir="rtl"] ._2hwGz {
					border-right: 0;
				}
				._2hwGz:dir(rtl) {
					border-right: 0;
				}
				._2hwGz {
					border-inline-start: 0;
				}
				[dir="ltr"] ._21hsI {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._21hsI:dir(ltr) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] ._21hsI {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._21hsI:dir(rtl) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._21hsI {
					border-inline-end: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] ._17Nt6 {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._17Nt6:dir(ltr) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] ._17Nt6 {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._17Nt6:dir(rtl) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._17Nt6 {
					border-inline-end: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] ._3HA6W {
					border-right: 0;
				}
				._3HA6W:dir(ltr) {
					border-right: 0;
				}
				[dir="rtl"] ._3HA6W {
					border-left: 0;
				}
				._3HA6W:dir(rtl) {
					border-left: 0;
				}
				._3HA6W {
					border-inline-end: 0;
				}
				.iZWtb {
					border-top: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.IiD_3 {
					border-top: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.yARoN {
					border-top: 0;
				}
				.a9NHq {
					border-bottom: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.qutp_ {
					border-bottom: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._2lbOP {
					border-bottom: 0;
				}
				[dir="ltr"] ._2euGI {
					border-left-width: var(--x-border-width-base);
				}
				._2euGI:dir(ltr) {
					border-left-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._2euGI {
					border-right-width: var(--x-border-width-base);
				}
				._2euGI:dir(rtl) {
					border-right-width: var(--x-border-width-base);
				}
				._2euGI {
					border-inline-start-width: var(--x-border-width-base);
				}
				[dir="ltr"] ._3Jj6Z {
					border-left-width: var(--x-border-width-thick);
				}
				._3Jj6Z:dir(ltr) {
					border-left-width: var(--x-border-width-thick);
				}
				[dir="rtl"] ._3Jj6Z {
					border-right-width: var(--x-border-width-thick);
				}
				._3Jj6Z:dir(rtl) {
					border-right-width: var(--x-border-width-thick);
				}
				._3Jj6Z {
					border-inline-start-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._2sGNv {
					border-right-width: var(--x-border-width-base);
				}
				._2sGNv:dir(ltr) {
					border-right-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._2sGNv {
					border-left-width: var(--x-border-width-base);
				}
				._2sGNv:dir(rtl) {
					border-left-width: var(--x-border-width-base);
				}
				._2sGNv {
					border-inline-end-width: var(--x-border-width-base);
				}
				[dir="ltr"] ._2zxxF {
					border-right-width: var(--x-border-width-thick);
				}
				._2zxxF:dir(ltr) {
					border-right-width: var(--x-border-width-thick);
				}
				[dir="rtl"] ._2zxxF {
					border-left-width: var(--x-border-width-thick);
				}
				._2zxxF:dir(rtl) {
					border-left-width: var(--x-border-width-thick);
				}
				._2zxxF {
					border-inline-end-width: var(--x-border-width-thick);
				}
				.rmBtx {
					border-top-width: var(--x-border-width-base);
				}
				._2bu1y {
					border-top-width: var(--x-border-width-thick);
				}
				._3W_Lv {
					border-bottom-width: var(--x-border-width-base);
				}
				._9uMy4 {
					border-bottom-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._1JB3c {
					border-left-color: var(--x-default-color-border);
				}
				._1JB3c:dir(ltr) {
					border-left-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._1JB3c {
					border-right-color: var(--x-default-color-border);
				}
				._1JB3c:dir(rtl) {
					border-right-color: var(--x-default-color-border);
				}
				._1JB3c {
					border-inline-start-color: var(--x-default-color-border);
				}
				[dir="ltr"] ._2LIDs {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._2LIDs:dir(ltr) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				[dir="rtl"] ._2LIDs {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._2LIDs:dir(rtl) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._2LIDs {
					border-inline-start-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._18vNE {
					border-right-color: var(--x-default-color-border);
				}
				._18vNE:dir(ltr) {
					border-right-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._18vNE {
					border-left-color: var(--x-default-color-border);
				}
				._18vNE:dir(rtl) {
					border-left-color: var(--x-default-color-border);
				}
				._18vNE {
					border-inline-end-color: var(--x-default-color-border);
				}
				[dir="ltr"] ._3hpDW {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._3hpDW:dir(ltr) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="rtl"] ._3hpDW {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._3hpDW:dir(rtl) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._3hpDW {
					border-inline-end-color: var(
						--x-default-color-border-emphasized
					);
				}
				.P5too {
					border-top-color: var(--x-default-color-border);
				}
				._3qG3Q {
					border-top-color: var(--x-default-color-border-emphasized);
				}
				._3SaBW {
					border-bottom-color: var(--x-default-color-border);
				}
				.daqDN {
					border-bottom-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._1Jl_s {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._1Jl_s:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._1Jl_s {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._1Jl_s:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._1Jl_s {
					border-start-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._2Rukp {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._2Rukp:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._2Rukp {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._2Rukp:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._2Rukp {
					border-start-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._1Y9wN {
					border-top-left-radius: 0;
				}
				._1Y9wN:dir(ltr) {
					border-top-left-radius: 0;
				}
				[dir="rtl"] ._1Y9wN {
					border-top-right-radius: 0;
				}
				._1Y9wN:dir(rtl) {
					border-top-right-radius: 0;
				}
				._1Y9wN {
					border-start-start-radius: 0;
				}
				[dir="ltr"] .BBMfm {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				.BBMfm:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] .BBMfm {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				.BBMfm:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				.BBMfm {
					border-end-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._1-fdi {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				._1-fdi:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._1-fdi {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._1-fdi:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._1-fdi {
					border-end-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._1B8d4 {
					border-bottom-left-radius: 0;
				}
				._1B8d4:dir(ltr) {
					border-bottom-left-radius: 0;
				}
				[dir="rtl"] ._1B8d4 {
					border-bottom-right-radius: 0;
				}
				._1B8d4:dir(rtl) {
					border-bottom-right-radius: 0;
				}
				._1B8d4 {
					border-end-start-radius: 0;
				}
				[dir="ltr"] .znv7n {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				.znv7n:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] .znv7n {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				.znv7n:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				.znv7n {
					border-start-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._3w_v1 {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._3w_v1:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._3w_v1 {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._3w_v1:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._3w_v1 {
					border-start-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] .rUEMr {
					border-top-right-radius: 0;
				}
				.rUEMr:dir(ltr) {
					border-top-right-radius: 0;
				}
				[dir="rtl"] .rUEMr {
					border-top-left-radius: 0;
				}
				.rUEMr:dir(rtl) {
					border-top-left-radius: 0;
				}
				.rUEMr {
					border-start-end-radius: 0;
				}
				[dir="ltr"] ._3hof8 {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._3hof8:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3hof8 {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._3hof8:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._3hof8 {
					border-end-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] .ACKH_ {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				.ACKH_:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] .ACKH_ {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				.ACKH_:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				.ACKH_ {
					border-end-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] .G2HoM {
					border-bottom-right-radius: 0;
				}
				.G2HoM:dir(ltr) {
					border-bottom-right-radius: 0;
				}
				[dir="rtl"] .G2HoM {
					border-bottom-left-radius: 0;
				}
				.G2HoM:dir(rtl) {
					border-bottom-left-radius: 0;
				}
				.G2HoM {
					border-end-end-radius: 0;
				}
			}
			@media screen and (min-width: 1000px) {
				[dir="ltr"] ._10Z-e {
					padding-left: var(--x-spacing-tight4x);
				}
				._10Z-e:dir(ltr) {
					padding-left: var(--x-spacing-tight4x);
				}
				[dir="rtl"] ._10Z-e {
					padding-right: var(--x-spacing-tight4x);
				}
				._10Z-e:dir(rtl) {
					padding-right: var(--x-spacing-tight4x);
				}
				._10Z-e {
					padding-inline-start: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._249SG {
					padding-left: var(--x-spacing-tight1x);
				}
				._249SG:dir(ltr) {
					padding-left: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._249SG {
					padding-right: var(--x-spacing-tight1x);
				}
				._249SG:dir(rtl) {
					padding-right: var(--x-spacing-tight1x);
				}
				._249SG {
					padding-inline-start: var(--x-spacing-tight1x);
				}
				[dir="ltr"] .js5rm {
					padding-left: var(--x-spacing-base);
				}
				.js5rm:dir(ltr) {
					padding-left: var(--x-spacing-base);
				}
				[dir="rtl"] .js5rm {
					padding-right: var(--x-spacing-base);
				}
				.js5rm:dir(rtl) {
					padding-right: var(--x-spacing-base);
				}
				.js5rm {
					padding-inline-start: var(--x-spacing-base);
				}
				[dir="ltr"] ._2i4Xp {
					padding-left: var(--x-spacing-loose1x);
				}
				._2i4Xp:dir(ltr) {
					padding-left: var(--x-spacing-loose1x);
				}
				[dir="rtl"] ._2i4Xp {
					padding-right: var(--x-spacing-loose1x);
				}
				._2i4Xp:dir(rtl) {
					padding-right: var(--x-spacing-loose1x);
				}
				._2i4Xp {
					padding-inline-start: var(--x-spacing-loose1x);
				}
				[dir="ltr"] ._1778b {
					padding-left: var(--x-spacing-loose4x);
				}
				._1778b:dir(ltr) {
					padding-left: var(--x-spacing-loose4x);
				}
				[dir="rtl"] ._1778b {
					padding-right: var(--x-spacing-loose4x);
				}
				._1778b:dir(rtl) {
					padding-right: var(--x-spacing-loose4x);
				}
				._1778b {
					padding-inline-start: var(--x-spacing-loose4x);
				}
				[dir="ltr"] .CXlpj {
					padding-left: 0;
				}
				.CXlpj:dir(ltr) {
					padding-left: 0;
				}
				[dir="rtl"] .CXlpj {
					padding-right: 0;
				}
				.CXlpj:dir(rtl) {
					padding-right: 0;
				}
				.CXlpj {
					padding-inline-start: 0;
				}
				[dir="ltr"] ._2SoxW {
					padding-right: var(--x-spacing-tight4x);
				}
				._2SoxW:dir(ltr) {
					padding-right: var(--x-spacing-tight4x);
				}
				[dir="rtl"] ._2SoxW {
					padding-left: var(--x-spacing-tight4x);
				}
				._2SoxW:dir(rtl) {
					padding-left: var(--x-spacing-tight4x);
				}
				._2SoxW {
					padding-inline-end: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._3ji7B {
					padding-right: var(--x-spacing-tight1x);
				}
				._3ji7B:dir(ltr) {
					padding-right: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._3ji7B {
					padding-left: var(--x-spacing-tight1x);
				}
				._3ji7B:dir(rtl) {
					padding-left: var(--x-spacing-tight1x);
				}
				._3ji7B {
					padding-inline-end: var(--x-spacing-tight1x);
				}
				[dir="ltr"] ._2M8jE {
					padding-right: var(--x-spacing-base);
				}
				._2M8jE:dir(ltr) {
					padding-right: var(--x-spacing-base);
				}
				[dir="rtl"] ._2M8jE {
					padding-left: var(--x-spacing-base);
				}
				._2M8jE:dir(rtl) {
					padding-left: var(--x-spacing-base);
				}
				._2M8jE {
					padding-inline-end: var(--x-spacing-base);
				}
				[dir="ltr"] ._2CNmM {
					padding-right: var(--x-spacing-loose1x);
				}
				._2CNmM:dir(ltr) {
					padding-right: var(--x-spacing-loose1x);
				}
				[dir="rtl"] ._2CNmM {
					padding-left: var(--x-spacing-loose1x);
				}
				._2CNmM:dir(rtl) {
					padding-left: var(--x-spacing-loose1x);
				}
				._2CNmM {
					padding-inline-end: var(--x-spacing-loose1x);
				}
				[dir="ltr"] .uZ3yl {
					padding-right: var(--x-spacing-loose4x);
				}
				.uZ3yl:dir(ltr) {
					padding-right: var(--x-spacing-loose4x);
				}
				[dir="rtl"] .uZ3yl {
					padding-left: var(--x-spacing-loose4x);
				}
				.uZ3yl:dir(rtl) {
					padding-left: var(--x-spacing-loose4x);
				}
				.uZ3yl {
					padding-inline-end: var(--x-spacing-loose4x);
				}
				[dir="ltr"] ._3OIrL {
					padding-right: 0;
				}
				._3OIrL:dir(ltr) {
					padding-right: 0;
				}
				[dir="rtl"] ._3OIrL {
					padding-left: 0;
				}
				._3OIrL:dir(rtl) {
					padding-left: 0;
				}
				._3OIrL {
					padding-inline-end: 0;
				}
				._3k7oJ {
					padding-top: var(--x-spacing-tight4x);
				}
				.ofOIu {
					padding-top: var(--x-spacing-tight1x);
				}
				._2Kaic {
					padding-top: var(--x-spacing-base);
				}
				._3yTnz {
					padding-top: var(--x-spacing-loose1x);
				}
				._2LKRh {
					padding-top: var(--x-spacing-loose4x);
				}
				._3oltS {
					padding-top: 0;
				}
				._1dknz {
					padding-bottom: var(--x-spacing-tight4x);
				}
				._3OpcV {
					padding-bottom: var(--x-spacing-tight1x);
				}
				._9qjVz {
					padding-bottom: var(--x-spacing-base);
				}
				._1Tn2c {
					padding-bottom: var(--x-spacing-loose1x);
				}
				._2C-i- {
					padding-bottom: var(--x-spacing-loose4x);
				}
				.Uh0IR {
					padding-bottom: 0;
				}
				._21ZHv {
					--x-default-color-subdued: var(
						--x-color-surface-primary-subdued
					);
					--x-default-color-text: var(--x-color-surface-primary-text);
					--x-default-color-text-subdued: var(
						--x-color-surface-primary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-primary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-primary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-primary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-primary-accent
					);
					background-color: var(--x-color-surface-primary);
				}
				._3TE8T,
				._21ZHv {
					color: var(--x-default-color-text);
				}
				._3TE8T {
					--x-default-color-subdued: var(
						--x-color-surface-secondary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-secondary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-secondary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-secondary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-secondary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-secondary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-secondary-accent
					);
					background-color: var(--x-color-surface-secondary);
				}
				.Frlr7 {
					--x-default-color-subdued: var(
						--x-color-surface-tertiary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-tertiary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-tertiary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-tertiary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-tertiary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-tertiary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-tertiary-accent
					);
					background-color: var(--x-color-surface-tertiary);
					color: var(--x-default-color-text);
				}
				.k88yQ {
					background-color: transparent;
				}
				[dir="ltr"] ._1kV0V {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1kV0V:dir(ltr) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] ._1kV0V {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1kV0V:dir(rtl) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1kV0V {
					border-inline-start: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] .ZEPDj {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.ZEPDj:dir(ltr) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] .ZEPDj {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.ZEPDj:dir(rtl) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.ZEPDj {
					border-inline-start: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] .OMm3U {
					border-left: 0;
				}
				.OMm3U:dir(ltr) {
					border-left: 0;
				}
				[dir="rtl"] .OMm3U {
					border-right: 0;
				}
				.OMm3U:dir(rtl) {
					border-right: 0;
				}
				.OMm3U {
					border-inline-start: 0;
				}
				[dir="ltr"] .Sh_uJ {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.Sh_uJ:dir(ltr) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] .Sh_uJ {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.Sh_uJ:dir(rtl) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.Sh_uJ {
					border-inline-end: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] ._2o3Fv {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._2o3Fv:dir(ltr) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] ._2o3Fv {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._2o3Fv:dir(rtl) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._2o3Fv {
					border-inline-end: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] ._1FDOd {
					border-right: 0;
				}
				._1FDOd:dir(ltr) {
					border-right: 0;
				}
				[dir="rtl"] ._1FDOd {
					border-left: 0;
				}
				._1FDOd:dir(rtl) {
					border-left: 0;
				}
				._1FDOd {
					border-inline-end: 0;
				}
				._3XGQu {
					border-top: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1O5jI {
					border-top: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._9RQ44 {
					border-top: 0;
				}
				._1obCE {
					border-bottom: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1g_Mf {
					border-bottom: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._5Uajk {
					border-bottom: 0;
				}
				[dir="ltr"] ._2eDHn {
					border-left-width: var(--x-border-width-base);
				}
				._2eDHn:dir(ltr) {
					border-left-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._2eDHn {
					border-right-width: var(--x-border-width-base);
				}
				._2eDHn:dir(rtl) {
					border-right-width: var(--x-border-width-base);
				}
				._2eDHn {
					border-inline-start-width: var(--x-border-width-base);
				}
				[dir="ltr"] .ZXCuD {
					border-left-width: var(--x-border-width-thick);
				}
				.ZXCuD:dir(ltr) {
					border-left-width: var(--x-border-width-thick);
				}
				[dir="rtl"] .ZXCuD {
					border-right-width: var(--x-border-width-thick);
				}
				.ZXCuD:dir(rtl) {
					border-right-width: var(--x-border-width-thick);
				}
				.ZXCuD {
					border-inline-start-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._1L29A {
					border-right-width: var(--x-border-width-base);
				}
				._1L29A:dir(ltr) {
					border-right-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._1L29A {
					border-left-width: var(--x-border-width-base);
				}
				._1L29A:dir(rtl) {
					border-left-width: var(--x-border-width-base);
				}
				._1L29A {
					border-inline-end-width: var(--x-border-width-base);
				}
				[dir="ltr"] .ZQ4P1 {
					border-right-width: var(--x-border-width-thick);
				}
				.ZQ4P1:dir(ltr) {
					border-right-width: var(--x-border-width-thick);
				}
				[dir="rtl"] .ZQ4P1 {
					border-left-width: var(--x-border-width-thick);
				}
				.ZQ4P1:dir(rtl) {
					border-left-width: var(--x-border-width-thick);
				}
				.ZQ4P1 {
					border-inline-end-width: var(--x-border-width-thick);
				}
				._2pvDQ {
					border-top-width: var(--x-border-width-base);
				}
				._3G19T {
					border-top-width: var(--x-border-width-thick);
				}
				._1vcII {
					border-bottom-width: var(--x-border-width-base);
				}
				.Cc5xk {
					border-bottom-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._38NY6 {
					border-left-color: var(--x-default-color-border);
				}
				._38NY6:dir(ltr) {
					border-left-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._38NY6 {
					border-right-color: var(--x-default-color-border);
				}
				._38NY6:dir(rtl) {
					border-right-color: var(--x-default-color-border);
				}
				._38NY6 {
					border-inline-start-color: var(--x-default-color-border);
				}
				[dir="ltr"] ._3HQf- {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._3HQf-:dir(ltr) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				[dir="rtl"] ._3HQf- {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._3HQf-:dir(rtl) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._3HQf- {
					border-inline-start-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._26cq4 {
					border-right-color: var(--x-default-color-border);
				}
				._26cq4:dir(ltr) {
					border-right-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._26cq4 {
					border-left-color: var(--x-default-color-border);
				}
				._26cq4:dir(rtl) {
					border-left-color: var(--x-default-color-border);
				}
				._26cq4 {
					border-inline-end-color: var(--x-default-color-border);
				}
				[dir="ltr"] .ktfJB {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				.ktfJB:dir(ltr) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="rtl"] .ktfJB {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				.ktfJB:dir(rtl) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				.ktfJB {
					border-inline-end-color: var(
						--x-default-color-border-emphasized
					);
				}
				._24SEY {
					border-top-color: var(--x-default-color-border);
				}
				._3rSA- {
					border-top-color: var(--x-default-color-border-emphasized);
				}
				.unUFg {
					border-bottom-color: var(--x-default-color-border);
				}
				._17cwJ {
					border-bottom-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._3omjQ {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._3omjQ:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3omjQ {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._3omjQ:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._3omjQ {
					border-start-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] .Q97kG {
					border-top-left-radius: var(--x-border-radius-base);
				}
				.Q97kG:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] .Q97kG {
					border-top-right-radius: var(--x-border-radius-base);
				}
				.Q97kG:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				.Q97kG {
					border-start-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._1BW3U {
					border-top-left-radius: 0;
				}
				._1BW3U:dir(ltr) {
					border-top-left-radius: 0;
				}
				[dir="rtl"] ._1BW3U {
					border-top-right-radius: 0;
				}
				._1BW3U:dir(rtl) {
					border-top-right-radius: 0;
				}
				._1BW3U {
					border-start-start-radius: 0;
				}
				[dir="ltr"] ._3U7Mu {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._3U7Mu:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3U7Mu {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._3U7Mu:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._3U7Mu {
					border-end-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._1MZp4 {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				._1MZp4:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._1MZp4 {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._1MZp4:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._1MZp4 {
					border-end-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._-27oP {
					border-bottom-left-radius: 0;
				}
				._-27oP:dir(ltr) {
					border-bottom-left-radius: 0;
				}
				[dir="rtl"] ._-27oP {
					border-bottom-right-radius: 0;
				}
				._-27oP:dir(rtl) {
					border-bottom-right-radius: 0;
				}
				._-27oP {
					border-end-start-radius: 0;
				}
				[dir="ltr"] ._3I-Ue {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._3I-Ue:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3I-Ue {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._3I-Ue:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._3I-Ue {
					border-start-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._1UcPy {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._1UcPy:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._1UcPy {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._1UcPy:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._1UcPy {
					border-start-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._1L8hM {
					border-top-right-radius: 0;
				}
				._1L8hM:dir(ltr) {
					border-top-right-radius: 0;
				}
				[dir="rtl"] ._1L8hM {
					border-top-left-radius: 0;
				}
				._1L8hM:dir(rtl) {
					border-top-left-radius: 0;
				}
				._1L8hM {
					border-start-end-radius: 0;
				}
				[dir="ltr"] ._10L5I {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._10L5I:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._10L5I {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._10L5I:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._10L5I {
					border-end-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] .wEs-c {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				.wEs-c:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] .wEs-c {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				.wEs-c:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				.wEs-c {
					border-end-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._30PgN {
					border-bottom-right-radius: 0;
				}
				._30PgN:dir(ltr) {
					border-bottom-right-radius: 0;
				}
				[dir="rtl"] ._30PgN {
					border-bottom-left-radius: 0;
				}
				._30PgN:dir(rtl) {
					border-bottom-left-radius: 0;
				}
				._30PgN {
					border-end-end-radius: 0;
				}
			}
			@media screen and (min-width: 1200px) {
				[dir="ltr"] ._tvYf {
					padding-left: var(--x-spacing-tight4x);
				}
				._tvYf:dir(ltr) {
					padding-left: var(--x-spacing-tight4x);
				}
				[dir="rtl"] ._tvYf {
					padding-right: var(--x-spacing-tight4x);
				}
				._tvYf:dir(rtl) {
					padding-right: var(--x-spacing-tight4x);
				}
				._tvYf {
					padding-inline-start: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._21Ia0 {
					padding-left: var(--x-spacing-tight1x);
				}
				._21Ia0:dir(ltr) {
					padding-left: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._21Ia0 {
					padding-right: var(--x-spacing-tight1x);
				}
				._21Ia0:dir(rtl) {
					padding-right: var(--x-spacing-tight1x);
				}
				._21Ia0 {
					padding-inline-start: var(--x-spacing-tight1x);
				}
				[dir="ltr"] ._1jRzX {
					padding-left: var(--x-spacing-base);
				}
				._1jRzX:dir(ltr) {
					padding-left: var(--x-spacing-base);
				}
				[dir="rtl"] ._1jRzX {
					padding-right: var(--x-spacing-base);
				}
				._1jRzX:dir(rtl) {
					padding-right: var(--x-spacing-base);
				}
				._1jRzX {
					padding-inline-start: var(--x-spacing-base);
				}
				[dir="ltr"] .n0VvM {
					padding-left: var(--x-spacing-loose1x);
				}
				.n0VvM:dir(ltr) {
					padding-left: var(--x-spacing-loose1x);
				}
				[dir="rtl"] .n0VvM {
					padding-right: var(--x-spacing-loose1x);
				}
				.n0VvM:dir(rtl) {
					padding-right: var(--x-spacing-loose1x);
				}
				.n0VvM {
					padding-inline-start: var(--x-spacing-loose1x);
				}
				[dir="ltr"] ._3Iqs9 {
					padding-left: var(--x-spacing-loose4x);
				}
				._3Iqs9:dir(ltr) {
					padding-left: var(--x-spacing-loose4x);
				}
				[dir="rtl"] ._3Iqs9 {
					padding-right: var(--x-spacing-loose4x);
				}
				._3Iqs9:dir(rtl) {
					padding-right: var(--x-spacing-loose4x);
				}
				._3Iqs9 {
					padding-inline-start: var(--x-spacing-loose4x);
				}
				[dir="ltr"] ._2P5Er {
					padding-left: 0;
				}
				._2P5Er:dir(ltr) {
					padding-left: 0;
				}
				[dir="rtl"] ._2P5Er {
					padding-right: 0;
				}
				._2P5Er:dir(rtl) {
					padding-right: 0;
				}
				._2P5Er {
					padding-inline-start: 0;
				}
				[dir="ltr"] .O6ocP {
					padding-right: var(--x-spacing-tight4x);
				}
				.O6ocP:dir(ltr) {
					padding-right: var(--x-spacing-tight4x);
				}
				[dir="rtl"] .O6ocP {
					padding-left: var(--x-spacing-tight4x);
				}
				.O6ocP:dir(rtl) {
					padding-left: var(--x-spacing-tight4x);
				}
				.O6ocP {
					padding-inline-end: var(--x-spacing-tight4x);
				}
				[dir="ltr"] ._2PzOS {
					padding-right: var(--x-spacing-tight1x);
				}
				._2PzOS:dir(ltr) {
					padding-right: var(--x-spacing-tight1x);
				}
				[dir="rtl"] ._2PzOS {
					padding-left: var(--x-spacing-tight1x);
				}
				._2PzOS:dir(rtl) {
					padding-left: var(--x-spacing-tight1x);
				}
				._2PzOS {
					padding-inline-end: var(--x-spacing-tight1x);
				}
				[dir="ltr"] ._1F39T {
					padding-right: var(--x-spacing-base);
				}
				._1F39T:dir(ltr) {
					padding-right: var(--x-spacing-base);
				}
				[dir="rtl"] ._1F39T {
					padding-left: var(--x-spacing-base);
				}
				._1F39T:dir(rtl) {
					padding-left: var(--x-spacing-base);
				}
				._1F39T {
					padding-inline-end: var(--x-spacing-base);
				}
				[dir="ltr"] ._25ogV {
					padding-right: var(--x-spacing-loose1x);
				}
				._25ogV:dir(ltr) {
					padding-right: var(--x-spacing-loose1x);
				}
				[dir="rtl"] ._25ogV {
					padding-left: var(--x-spacing-loose1x);
				}
				._25ogV:dir(rtl) {
					padding-left: var(--x-spacing-loose1x);
				}
				._25ogV {
					padding-inline-end: var(--x-spacing-loose1x);
				}
				[dir="ltr"] .Sbbsf {
					padding-right: var(--x-spacing-loose4x);
				}
				.Sbbsf:dir(ltr) {
					padding-right: var(--x-spacing-loose4x);
				}
				[dir="rtl"] .Sbbsf {
					padding-left: var(--x-spacing-loose4x);
				}
				.Sbbsf:dir(rtl) {
					padding-left: var(--x-spacing-loose4x);
				}
				.Sbbsf {
					padding-inline-end: var(--x-spacing-loose4x);
				}
				[dir="ltr"] ._30jK5 {
					padding-right: 0;
				}
				._30jK5:dir(ltr) {
					padding-right: 0;
				}
				[dir="rtl"] ._30jK5 {
					padding-left: 0;
				}
				._30jK5:dir(rtl) {
					padding-left: 0;
				}
				._30jK5 {
					padding-inline-end: 0;
				}
				._1feR2 {
					padding-top: var(--x-spacing-tight4x);
				}
				._31yt5 {
					padding-top: var(--x-spacing-tight1x);
				}
				._2tUwY {
					padding-top: var(--x-spacing-base);
				}
				._2eV_x {
					padding-top: var(--x-spacing-loose1x);
				}
				._3geo3 {
					padding-top: var(--x-spacing-loose4x);
				}
				._1uDSn {
					padding-top: 0;
				}
				._2S59e {
					padding-bottom: var(--x-spacing-tight4x);
				}
				._2qYHP {
					padding-bottom: var(--x-spacing-tight1x);
				}
				._1ckxP {
					padding-bottom: var(--x-spacing-base);
				}
				._2OOKo {
					padding-bottom: var(--x-spacing-loose1x);
				}
				._3jBfo {
					padding-bottom: var(--x-spacing-loose4x);
				}
				._3Ajmu {
					padding-bottom: 0;
				}
				._1U68v {
					--x-default-color-subdued: var(
						--x-color-surface-primary-subdued
					);
					--x-default-color-text: var(--x-color-surface-primary-text);
					--x-default-color-text-subdued: var(
						--x-color-surface-primary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-primary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-primary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-primary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-primary-accent
					);
					background-color: var(--x-color-surface-primary);
				}
				._1U68v,
				._2xnmb {
					color: var(--x-default-color-text);
				}
				._2xnmb {
					--x-default-color-subdued: var(
						--x-color-surface-secondary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-secondary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-secondary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-secondary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-secondary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-secondary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-secondary-accent
					);
					background-color: var(--x-color-surface-secondary);
				}
				._2CH9P {
					--x-default-color-subdued: var(
						--x-color-surface-tertiary-subdued
					);
					--x-default-color-text: var(
						--x-color-surface-tertiary-text
					);
					--x-default-color-text-subdued: var(
						--x-color-surface-tertiary-text-subdued
					);
					--x-default-color-text-emphasized: var(
						--x-color-surface-tertiary-text-emphasized
					);
					--x-default-color-border: var(
						--x-color-surface-tertiary-border
					);
					--x-default-color-border-emphasized: var(
						--x-color-surface-tertiary-border-emphasized
					);
					--x-default-color-accent: var(
						--x-color-surface-tertiary-accent
					);
					background-color: var(--x-color-surface-tertiary);
					color: var(--x-default-color-text);
				}
				.BBr4t {
					background-color: transparent;
				}
				[dir="ltr"] .DP9XE {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.DP9XE:dir(ltr) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] .DP9XE {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.DP9XE:dir(rtl) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				.DP9XE {
					border-inline-start: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] .Tx8yT {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.Tx8yT:dir(ltr) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] .Tx8yT {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.Tx8yT:dir(rtl) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.Tx8yT {
					border-inline-start: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] ._1Dd3Z {
					border-left: 0;
				}
				._1Dd3Z:dir(ltr) {
					border-left: 0;
				}
				[dir="rtl"] ._1Dd3Z {
					border-right: 0;
				}
				._1Dd3Z:dir(rtl) {
					border-right: 0;
				}
				._1Dd3Z {
					border-inline-start: 0;
				}
				[dir="ltr"] ._3fhOc {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._3fhOc:dir(ltr) {
					border-right: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="rtl"] ._3fhOc {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._3fhOc:dir(rtl) {
					border-left: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._3fhOc {
					border-inline-end: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				[dir="ltr"] .sfTwg {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.sfTwg:dir(ltr) {
					border-right: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="rtl"] .sfTwg {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.sfTwg:dir(rtl) {
					border-left: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.sfTwg {
					border-inline-end: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				[dir="ltr"] ._2Y83_ {
					border-right: 0;
				}
				._2Y83_:dir(ltr) {
					border-right: 0;
				}
				[dir="rtl"] ._2Y83_ {
					border-left: 0;
				}
				._2Y83_:dir(rtl) {
					border-left: 0;
				}
				._2Y83_ {
					border-inline-end: 0;
				}
				._3ExBr {
					border-top: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._3OGb3 {
					border-top: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				._4i00P {
					border-top: 0;
				}
				._2TgHg {
					border-bottom: var(--x-border-width-base) solid
						var(--x-default-color-border);
				}
				._1lT6t {
					border-bottom: var(--x-border-width-base) dotted
						var(--x-default-color-border);
				}
				.v3kVp {
					border-bottom: 0;
				}
				[dir="ltr"] ._32Ae_ {
					border-left-width: var(--x-border-width-base);
				}
				._32Ae_:dir(ltr) {
					border-left-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._32Ae_ {
					border-right-width: var(--x-border-width-base);
				}
				._32Ae_:dir(rtl) {
					border-right-width: var(--x-border-width-base);
				}
				._32Ae_ {
					border-inline-start-width: var(--x-border-width-base);
				}
				[dir="ltr"] ._39g32 {
					border-left-width: var(--x-border-width-thick);
				}
				._39g32:dir(ltr) {
					border-left-width: var(--x-border-width-thick);
				}
				[dir="rtl"] ._39g32 {
					border-right-width: var(--x-border-width-thick);
				}
				._39g32:dir(rtl) {
					border-right-width: var(--x-border-width-thick);
				}
				._39g32 {
					border-inline-start-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._2xZrV {
					border-right-width: var(--x-border-width-base);
				}
				._2xZrV:dir(ltr) {
					border-right-width: var(--x-border-width-base);
				}
				[dir="rtl"] ._2xZrV {
					border-left-width: var(--x-border-width-base);
				}
				._2xZrV:dir(rtl) {
					border-left-width: var(--x-border-width-base);
				}
				._2xZrV {
					border-inline-end-width: var(--x-border-width-base);
				}
				[dir="ltr"] .xwgaA {
					border-right-width: var(--x-border-width-thick);
				}
				.xwgaA:dir(ltr) {
					border-right-width: var(--x-border-width-thick);
				}
				[dir="rtl"] .xwgaA {
					border-left-width: var(--x-border-width-thick);
				}
				.xwgaA:dir(rtl) {
					border-left-width: var(--x-border-width-thick);
				}
				.xwgaA {
					border-inline-end-width: var(--x-border-width-thick);
				}
				.M5hkb {
					border-top-width: var(--x-border-width-base);
				}
				._23j8V {
					border-top-width: var(--x-border-width-thick);
				}
				.wSqGf {
					border-bottom-width: var(--x-border-width-base);
				}
				._2Fboa {
					border-bottom-width: var(--x-border-width-thick);
				}
				[dir="ltr"] ._2pLgJ {
					border-left-color: var(--x-default-color-border);
				}
				._2pLgJ:dir(ltr) {
					border-left-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._2pLgJ {
					border-right-color: var(--x-default-color-border);
				}
				._2pLgJ:dir(rtl) {
					border-right-color: var(--x-default-color-border);
				}
				._2pLgJ {
					border-inline-start-color: var(--x-default-color-border);
				}
				[dir="ltr"] ._2oNQQ {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._2oNQQ:dir(ltr) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				[dir="rtl"] ._2oNQQ {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._2oNQQ:dir(rtl) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._2oNQQ {
					border-inline-start-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._1lsh8 {
					border-right-color: var(--x-default-color-border);
				}
				._1lsh8:dir(ltr) {
					border-right-color: var(--x-default-color-border);
				}
				[dir="rtl"] ._1lsh8 {
					border-left-color: var(--x-default-color-border);
				}
				._1lsh8:dir(rtl) {
					border-left-color: var(--x-default-color-border);
				}
				._1lsh8 {
					border-inline-end-color: var(--x-default-color-border);
				}
				[dir="ltr"] ._3Ai8X {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				._3Ai8X:dir(ltr) {
					border-right-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="rtl"] ._3Ai8X {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._3Ai8X:dir(rtl) {
					border-left-color: var(--x-default-color-border-emphasized);
				}
				._3Ai8X {
					border-inline-end-color: var(
						--x-default-color-border-emphasized
					);
				}
				._1XeCG {
					border-top-color: var(--x-default-color-border);
				}
				._RADe {
					border-top-color: var(--x-default-color-border-emphasized);
				}
				._18AJ1 {
					border-bottom-color: var(--x-default-color-border);
				}
				._2ciER {
					border-bottom-color: var(
						--x-default-color-border-emphasized
					);
				}
				[dir="ltr"] ._3WSz4 {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._3WSz4:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3WSz4 {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._3WSz4:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._3WSz4 {
					border-start-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._2sZOH {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._2sZOH:dir(ltr) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._2sZOH {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._2sZOH:dir(rtl) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._2sZOH {
					border-start-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._3uPR- {
					border-top-left-radius: 0;
				}
				._3uPR-:dir(ltr) {
					border-top-left-radius: 0;
				}
				[dir="rtl"] ._3uPR- {
					border-top-right-radius: 0;
				}
				._3uPR-:dir(rtl) {
					border-top-right-radius: 0;
				}
				._3uPR- {
					border-start-start-radius: 0;
				}
				[dir="ltr"] ._3hCNS {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				._3hCNS:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._3hCNS {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._3hCNS:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				._3hCNS {
					border-end-start-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._3medq {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				._3medq:dir(ltr) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._3medq {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._3medq:dir(rtl) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._3medq {
					border-end-start-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] .vlbPd {
					border-bottom-left-radius: 0;
				}
				.vlbPd:dir(ltr) {
					border-bottom-left-radius: 0;
				}
				[dir="rtl"] .vlbPd {
					border-bottom-right-radius: 0;
				}
				.vlbPd:dir(rtl) {
					border-bottom-right-radius: 0;
				}
				.vlbPd {
					border-end-start-radius: 0;
				}
				[dir="ltr"] ._1YS31 {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				._1YS31:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] ._1YS31 {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._1YS31:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-tight);
				}
				._1YS31 {
					border-start-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._19lzo {
					border-top-right-radius: var(--x-border-radius-base);
				}
				._19lzo:dir(ltr) {
					border-top-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._19lzo {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._19lzo:dir(rtl) {
					border-top-left-radius: var(--x-border-radius-base);
				}
				._19lzo {
					border-start-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] .HvrsW {
					border-top-right-radius: 0;
				}
				.HvrsW:dir(ltr) {
					border-top-right-radius: 0;
				}
				[dir="rtl"] .HvrsW {
					border-top-left-radius: 0;
				}
				.HvrsW:dir(rtl) {
					border-top-left-radius: 0;
				}
				.HvrsW {
					border-start-end-radius: 0;
				}
				[dir="ltr"] .GSLn3 {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				.GSLn3:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-tight);
				}
				[dir="rtl"] .GSLn3 {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				.GSLn3:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-tight);
				}
				.GSLn3 {
					border-end-end-radius: var(--x-border-radius-tight);
				}
				[dir="ltr"] ._2grce {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				._2grce:dir(ltr) {
					border-bottom-right-radius: var(--x-border-radius-base);
				}
				[dir="rtl"] ._2grce {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				._2grce:dir(rtl) {
					border-bottom-left-radius: var(--x-border-radius-base);
				}
				._2grce {
					border-end-end-radius: var(--x-border-radius-base);
				}
				[dir="ltr"] ._2ZJ9u {
					border-bottom-right-radius: 0;
				}
				._2ZJ9u:dir(ltr) {
					border-bottom-right-radius: 0;
				}
				[dir="rtl"] ._2ZJ9u {
					border-bottom-left-radius: 0;
				}
				._2ZJ9u:dir(rtl) {
					border-bottom-left-radius: 0;
				}
				._2ZJ9u {
					border-end-end-radius: 0;
				}
			}
			._1vAUS {
				display: flex;
				flex-direction: column;
			}
			._1vAUS > * + * {
				margin-top: var(--x-spacing-base);
			}
			._1vAUS ._1vAUS {
				min-width: 0;
			}
			@supports (display: grid) {
				._1vAUS {
					display: grid;
					grid-row-gap: var(--x-spacing-base);
				}
				._1vAUS > * + * {
					margin-top: 0 !important;
				}
			}
			._1ByDS > * + * {
				margin-top: 0;
			}
			@supports (display: grid) {
				._1ByDS {
					grid-row-gap: 0;
				}
			}
			.xfmA9 > * + * {
				margin-top: var(--x-spacing-tight4x);
			}
			@supports (display: grid) {
				.xfmA9 {
					grid-row-gap: var(--x-spacing-tight4x);
				}
			}
			._3A2JP > * + * {
				margin-top: var(--x-spacing-tight1x);
			}
			@supports (display: grid) {
				._3A2JP {
					grid-row-gap: var(--x-spacing-tight1x);
				}
			}
			._2ZEt1 > * + * {
				margin-top: var(--x-spacing-loose1x);
			}
			@supports (display: grid) {
				._2ZEt1 {
					grid-row-gap: var(--x-spacing-loose1x);
				}
			}
			.HDACL > * + * {
				margin-top: var(--x-spacing-loose4x);
			}
			@supports (display: grid) {
				.HDACL {
					grid-row-gap: var(--x-spacing-loose4x);
				}
			}
			._389hR {
				align-items: flex-start;
			}
			@supports (display: grid) {
				._389hR {
					justify-items: start;
				}
			}
			.H2RUw {
				align-items: center;
			}
			@supports (display: grid) {
				.H2RUw {
					justify-items: center;
				}
			}
			._2rSdy {
				align-items: flex-end;
			}
			@supports (display: grid) {
				._2rSdy {
					justify-items: end;
				}
			}
			._2pOWh {
				-webkit-tap-highlight-color: transparent;
				-webkit-touch-callout: none;
				position: relative;
				cursor: pointer;
				background-color: var(--x-color-primary-action);
				border-radius: var(
					--x-control-border-radius,
					var(--x-global-border-radius)
				);
				color: var(--x-color-primary-action-text);
				display: inline-block;
				font-weight: var(--x-typography-primary-weight-bold);
				padding: var(--x-primary-button-block-padding)
					var(--x-primary-button-inline-padding);
				text-align: center;
				text-decoration: none;
				text-transform: var(--x-global-typography-letter-case);
				transition: background-color var(--x-duration-base)
						var(--x-timing-base),
					color var(--x-duration-base) var(--x-timing-base);
			}
			._2pOWh:hover {
				background-color: var(--x-color-primary-action-hovered);
			}
			._2pOWh:active {
				background-color: var(--x-color-primary-action-pressed);
				outline: none;
			}
			@media (-ms-high-contrast: active) {
				._2pOWh {
					border: 1px solid transparent;
				}
			}
			._9I39O {
				--this-line-height: 1.5rem;
				display: block;
				line-height: var(--this-line-height);
			}
			._3HGi5,
			._9I39O {
				transition: opacity var(--x-duration-slow) var(--x-timing-base);
			}
			._3I9ok {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
			._1omM3,
			._3qszd {
				background-color: transparent;
				color: var(--x-color-primary-action);
			}
			._1omM3:hover,
			._3qszd:hover {
				background-color: transparent;
				color: var(--x-color-primary-action-hovered);
			}
			._1omM3:active,
			._3qszd:active {
				background-color: transparent;
				color: var(--x-color-primary-action-pressed);
			}
			._1omM3 {
				font-weight: var(--x-typography-primary-weight-base);
				padding: 0;
				border-radius: var(--x-border-radius-none);
				background-color: var(--x-color-interactive);
				color: var(--x-color-interactive-text);
				transition: background-color var(--x-duration-base)
						var(--x-timing-base),
					color var(--x-duration-base) var(--x-timing-base);
			}
			._1omM3:hover {
				--this-background-color: var(--x-color-interactive-hovered);
				--this-color: var(--x-color-interactive-text-hovered);
			}
			._1omM3:active,
			._1omM3:hover {
				background-color: var(--this-background-color);
				color: var(--this-color);
			}
			._1omM3:active {
				--this-background-color: var(--x-color-interactive-pressed);
				--this-color: var(--x-color-interactive-text-pressed);
			}
			._1omM3:before {
				content: "";
				position: absolute;
				top: -0.35714285714285715em;
				right: -0.35714285714285715em;
				bottom: -0.35714285714285715em;
				left: -0.35714285714285715em;
				inset: -0.35714285714285715em;
				z-index: 0;
			}
			@media (any-hover: none) {
				._1omM3:before {
					top: -1.4285714285714286em;
					right: -1.7142857142857142em;
					bottom: -1.4285714285714286em;
					left: -1.7142857142857142em;
					inset: -1.4285714285714286em -1.7142857142857142em;
				}
			}
			._1omM3 ._9I39O {
				z-index: 1;
				position: relative;
			}
			._3VOwe {
				text-decoration: underline;
			}
			._10zXD {
				display: flex;
				justify-content: center;
				min-width: 100%;
			}
			._10zXD._1omM3 {
				margin: 0;
				padding: 0;
			}
			._3qszd {
				box-shadow: inset 0 0 0 1px var(--x-default-color-border);
			}
			._3FeEM,
			.QSV0Q {
				pointer-events: none;
				cursor: default;
			}
			.QSV0Q {
				background-color: #d9d9d9;
				color: #fff;
			}
			.ei_NT ._3HGi5 {
				opacity: 0;
			}
			@media screen and (prefers-reduced-motion: reduce) {
				.ei_NT ._9I39O {
					display: none;
				}
			}
			._2ZZOO ._3HGi5,
			._25m9f ._3HGi5 {
				opacity: 1;
			}
			._2ZZOO ._9I39O,
			._25m9f ._9I39O {
				opacity: 0;
			}
			@media screen and (prefers-reduced-motion: reduce) {
				._2ZZOO ._9I39O,
				._25m9f ._9I39O {
					display: none;
				}
			}
			._1yHt5 {
				background-color: var(--x-color-secondary-action);
				color: var(--x-color-secondary-action-text);
				padding: var(--x-secondary-button-block-padding)
					var(--x-secondary-button-inline-padding);
			}
			._1yHt5:hover {
				background-color: var(--x-color-secondary-action-hovered);
			}
			._1yHt5:active {
				background-color: var(--x-color-secondary-action-pressed);
				outline: none;
			}
			._1MUtm {
				background-color: var(--x-color-tertiary-action);
				color: var(--x-color-tertiary-action-text);
				padding: var(--x-tertiary-button-block-padding)
					var(--x-tertiary-button-inline-padding);
			}
			._2aRQj {
				padding-bottom: 0;
				padding-top: 0;
				height: 3.357142857142857em;
			}
			.EHJ_E {
				pointer-events: none;
				cursor: default;
				background-color: var(--x-color-primary-action-pressed);
				position: relative;
				overflow: hidden;
			}
			.EHJ_E ._9I39O {
				position: relative;
				z-index: 1;
			}
			.EHJ_E:before {
				content: "";
				position: absolute;
				background-color: var(--x-color-primary-action);
				z-index: 0;
				left: 0;
				top: 0;
				bottom: 0;
				width: 100%;
				transform: scaleX(0);
				transform-origin: left;
				animation-name: _2deMr;
				animation-duration: 20s;
				animation-iteration-count: infinite;
				animation-timing-function: cubic-bezier(0, 1, 0.5, 1);
				animation-delay: var(--x-duration-base);
			}
			.EHJ_E._1yHt5 {
				background-color: var(--x-color-secondary-action-pressed);
			}
			.EHJ_E._1yHt5:before {
				background-color: var(--x-color-secondary-action);
			}
			.EHJ_E.QSV0Q {
				background-color: #d9d9d9;
			}
			.EHJ_E.QSV0Q:before {
				background-color: #bfbfbf;
			}
			.EHJ_E._1omM3,
			.EHJ_E._3qszd {
				background-color: transparent;
			}
			.EHJ_E._1omM3:before,
			.EHJ_E._3qszd:before {
				background-color: var(--x-color-primary-action);
				top: calc(100% - 0.2rem);
			}
			@media screen and (prefers-reduced-motion: reduce) {
				.EHJ_E:before {
					animation: none;
				}
			}
			@keyframes _2deMr {
				0% {
					transform: scaleX(0);
				}
				5% {
					transform: scaleX(0.2);
				}
				10% {
					transform: scaleX(0.25);
				}
				15% {
					transform: scaleX(0.3);
				}
				20% {
					transform: scaleX(0.35);
				}
				25% {
					transform: scaleX(0.45);
				}
				30% {
					transform: scaleX(0.5);
				}
				35% {
					transform: scaleX(0.55);
				}
				40% {
					transform: scaleX(0.6);
				}
				45% {
					transform: scaleX(0.7);
				}
				50% {
					transform: scaleX(0.8);
				}
				55% {
					transform: scaleX(0.82);
				}
				60% {
					transform: scaleX(0.84);
				}
				65% {
					transform: scaleX(0.86);
				}
				70% {
					transform: scaleX(0.88);
				}
				75% {
					transform: scaleX(0.9);
				}
				80% {
					transform: scaleX(0.92);
				}
				85% {
					transform: scaleX(0.94);
				}
				90% {
					transform: scaleX(0.96);
				}
				95% {
					transform: scaleX(0.98);
				}
				to {
					transform: scaleX(1);
				}
			}
			._3UXaK:hover {
				background-color: var(--x-color1, var(--this-background-color));
				color: var(--x-color1-text, var(--this-color));
			}
			._2veqF:hover {
				background-color: var(--x-color2, var(--this-background-color));
				color: var(--x-color2-text, var(--this-color));
			}
			._8VGAD:active {
				background-color: var(--x-color1, var(--this-background-color));
				color: var(--x-color1-text, var(--this-color));
			}
			._3RHlk:active {
				background-color: var(--x-color2, var(--this-background-color));
				color: var(--x-color2-text, var(--this-color));
			}
			._2tpyl {
				width: 2.2857142857142856em;
				height: 2.2857142857142856em;
				animation: NqNy1 0.5s var(--x-timing-base),
					_1inUU 0.5s linear infinite;
			}
			._1SvDL {
				width: 4.571428571428571em;
				height: 4.571428571428571em;
			}
			._2aGG0 {
				width: 1.4285714285714286em;
				height: 1.4285714285714286em;
			}
			@keyframes _1inUU {
				0% {
					transform: rotate(0);
				}
				to {
					transform: rotate(1turn);
				}
			}
			@keyframes NqNy1 {
				0% {
					opacity: 0;
				}
				to {
					opacity: 1;
				}
			}
			._3qEsW {
				display: flex;
			}
			[dir="ltr"] ._3qEsW > * + * {
				margin-left: var(--x-spacing-base);
			}
			._3qEsW > * + :dir(ltr) {
				margin-left: var(--x-spacing-base);
			}
			[dir="rtl"] ._3qEsW > * + * {
				margin-right: var(--x-spacing-base);
			}
			._3qEsW > * + :dir(rtl) {
				margin-right: var(--x-spacing-base);
			}
			._3qEsW > * + * {
				margin-inline-start: var(--x-spacing-base);
			}
			@supports (display: grid) {
				._3qEsW {
					display: grid;
					grid-auto-flow: column;
					grid-auto-columns: auto;
					grid-column-gap: var(--x-spacing-base);
					justify-content: start;
				}
				[dir="ltr"] ._3qEsW > * + * {
					margin-left: 0 !important;
				}
				._3qEsW > * + :dir(ltr) {
					margin-left: 0 !important;
				}
				[dir="rtl"] ._3qEsW > * + * {
					margin-right: 0 !important;
				}
				._3qEsW > * + :dir(rtl) {
					margin-right: 0 !important;
				}
				._3qEsW > * + * {
					margin-inline-start: 0 !important;
				}
			}
			[dir="ltr"] ._355mn > * + * {
				margin-left: var(--x-spacing-tight4x);
			}
			._355mn > * + :dir(ltr) {
				margin-left: var(--x-spacing-tight4x);
			}
			[dir="rtl"] ._355mn > * + * {
				margin-right: var(--x-spacing-tight4x);
			}
			._355mn > * + :dir(rtl) {
				margin-right: var(--x-spacing-tight4x);
			}
			._355mn > * + * {
				margin-inline-start: var(--x-spacing-tight4x);
			}
			@supports (display: grid) {
				._355mn {
					grid-column-gap: var(--x-spacing-tight4x);
				}
			}
			[dir="ltr"] ._23fMX > * + * {
				margin-left: var(--x-spacing-tight1x);
			}
			._23fMX > * + :dir(ltr) {
				margin-left: var(--x-spacing-tight1x);
			}
			[dir="rtl"] ._23fMX > * + * {
				margin-right: var(--x-spacing-tight1x);
			}
			._23fMX > * + :dir(rtl) {
				margin-right: var(--x-spacing-tight1x);
			}
			._23fMX > * + * {
				margin-inline-start: var(--x-spacing-tight1x);
			}
			@supports (display: grid) {
				._23fMX {
					grid-column-gap: var(--x-spacing-tight1x);
				}
			}
			[dir="ltr"] ._3GMhh > * + * {
				margin-left: var(--x-spacing-loose1x);
			}
			._3GMhh > * + :dir(ltr) {
				margin-left: var(--x-spacing-loose1x);
			}
			[dir="rtl"] ._3GMhh > * + * {
				margin-right: var(--x-spacing-loose1x);
			}
			._3GMhh > * + :dir(rtl) {
				margin-right: var(--x-spacing-loose1x);
			}
			._3GMhh > * + * {
				margin-inline-start: var(--x-spacing-loose1x);
			}
			@supports (display: grid) {
				._3GMhh {
					grid-column-gap: var(--x-spacing-loose1x);
				}
			}
			[dir="ltr"] ._3wkU2 > * + * {
				margin-left: var(--x-spacing-loose4x);
			}
			._3wkU2 > * + :dir(ltr) {
				margin-left: var(--x-spacing-loose4x);
			}
			[dir="rtl"] ._3wkU2 > * + * {
				margin-right: var(--x-spacing-loose4x);
			}
			._3wkU2 > * + :dir(rtl) {
				margin-right: var(--x-spacing-loose4x);
			}
			._3wkU2 > * + * {
				margin-inline-start: var(--x-spacing-loose4x);
			}
			@supports (display: grid) {
				._3wkU2 {
					grid-column-gap: var(--x-spacing-loose4x);
				}
			}
			._3-4-Y {
				align-items: flex-start;
			}
			@supports (display: grid) {
				._3-4-Y {
					align-items: start;
				}
			}
			._1iYaY {
				align-items: center;
			}
			@supports (display: grid) {
				._1iYaY {
					align-items: center;
				}
			}
			._26YL4 {
				align-items: flex-end;
			}
			@supports (display: grid) {
				._26YL4 {
					align-items: end;
				}
			}
			.Onw9y {
				align-items: baseline;
			}
			@supports (display: grid) {
				.Onw9y {
					align-items: baseline;
				}
			}
			._1lYMV {
				padding: var(--x-spacing-loose);
			}
			._37M-H {
				border-top: 1px solid var(--x-default-color-border);
				border-bottom: 1px solid var(--x-default-color-border);
			}
			.UDz5V {
				--x-default-color-border: var(
					--x-color-surface-secondary-border
				);
				--x-default-color-border-emphasized: var(
					--x-color-surface-secondary-border-emphasized
				);
				--x-default-color-text: var(--x-color-surface-secondary-text);
				--x-default-color-text-subdued: var(
					--x-color-surface-secondary-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-surface-secondary-text-emphasized
				);
				background-color: var(--x-color-surface-secondary);
				color: var(--x-default-color-text, inherit);
			}
			.PGP-O {
				background-color: transparent;
			}
			._3dRLN {
				display: grid;
				justify-content: start;
				align-items: start;
				grid-template:
					"checkbox gap label" auto/auto var(--x-spacing-tight1x)
					auto;
			}
			._2UUr6 {
				grid-template:
					"checkbox gap label" auto "row-gap row-gap row-gap" var(
						--x-spacing-tight1x
					)
					"error error error" auto/auto var(--x-spacing-tight1x) auto;
			}
			._2UUr6._1BJ0v {
				grid-template:
					"checkbox gap label" auto "row-gap row-gap row-gap" var(
						--x-spacing-tight1x
					)
					"error-gap error-gap error" auto/auto var(
						--x-spacing-tight1x
					)
					auto;
			}
			._1NT-A {
				position: relative;
				margin-top: -1px;
				grid-area: checkbox;
				width: var(--x-checkbox-size);
				height: var(--x-checkbox-size);
			}
			._1NT-A,
			._2UUr6._1BJ0v > ._1NT-A,
			._2UUr6 > ._1NT-A {
				-ms-grid-row: 1;
				-ms-grid-column: 1;
			}
			.CehHN {
				--input-border-color: var(--x-default-color-border);
				--input-border-radius: var(
					--x-checkbox-border-radius,
					var(
						--x-control-border-radius,
						var(--x-global-border-radius)
					)
				);
				background-clip: padding-box;
				border: 1px solid transparent;
				border-radius: var(--input-border-radius);
				box-sizing: content-box;
				cursor: pointer;
				box-shadow: 0 0 0 1px var(--input-border-color) inset;
				outline: none;
			}
			.CehHN,
			.CehHN:before {
				display: block;
				width: 100%;
				height: 100%;
				transition: box-shadow var(--x-duration-base)
					var(--x-timing-ease-out);
			}
			.CehHN:before {
				content: "";
				border-radius: calc(var(--input-border-radius) / 2);
				pointer-events: none;
				box-shadow: 0 0 0 0 var(--x-color-interactive-text) inset,
					0 0 0 0 var(--x-color-interactive-text);
				opacity: 0.3;
			}
			.CehHN:active,
			.CehHN:focus {
				box-shadow: 0 0 0 1px var(--x-color-interactive-text) inset;
			}
			.CehHN:active:before,
			.CehHN:focus:before {
				box-shadow: 0 0 0 0.07142857142857142em
						var(--x-color-interactive-text) inset,
					0 0 0 0.21428571428571427em var(--x-color-interactive-text);
			}
			.CehHN:checked {
				box-shadow: 0 0 0 0.7142857142857143em
					var(--x-color-interactive-text) inset;
			}
			.CehHN:checked + .idBh2 {
				opacity: 1;
			}
			.CehHN._1jdC6:not(:checked) {
				box-shadow: 0 0 0 0.14285714285714285em
					var(--x-color-critical-accent) inset;
			}
			.CehHN._1jdC6:not(:checked):active:before,
			.CehHN._1jdC6:not(:checked):focus:before {
				box-shadow: 0 0 0 0.07142857142857142em
						var(--x-color-critical-accent) inset,
					0 0 0 0.21428571428571427em var(--x-color-critical-accent);
			}
			.BnZ5_ {
				background-color: transparent;
			}
			._2E56s {
				background-color: var(--x-color-surface-primary);
			}
			._2E56s,
			._3Q0BW {
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
			}
			._3Q0BW {
				background-color: var(--x-color-surface-secondary);
			}
			._3Y5VT {
				--x-default-color-accent: var(
					--x-color-surface-tertiary-accent
				);
				background-color: var(--x-color-surface-tertiary);
			}
			._2ko8r {
				--input-border-color: var(--x-default-color-border-emphasized);
			}
			._1Ot_a {
				opacity: 0.7;
				cursor: default;
			}
			._1Ot_a:before {
				display: none;
			}
			._1Ot_a._2E56s {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._1Ot_a._3Q0BW {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._1Ot_a._3Y5VT {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			._16Ge_ {
				display: block;
				max-width: 100%;
				cursor: pointer;
				grid-area: label;
			}
			._2UUr6._1BJ0v > ._16Ge_,
			._2UUr6 > ._16Ge_,
			._16Ge_ {
				-ms-grid-row: 1;
				-ms-grid-column: 3;
			}
			._3Wbwq {
				cursor: default;
			}
			._28kkx {
				-ms-grid-row: 3;
				-ms-grid-column: 1;
				-ms-grid-column-span: 3;
				grid-area: error;
			}
			._2UUr6._1BJ0v > ._28kkx {
				-ms-grid-row: 3;
				-ms-grid-column: 3;
				-ms-grid-column-span: 1;
			}
			.idBh2 {
				color: var(--x-color-interactive-icon);
				pointer-events: none;
				opacity: 0;
				transform-origin: center;
				transform: translate(-50%, -50%);
				position: absolute;
				top: calc(50% + 1px);
				left: calc(50% + 1px);
				transition: all var(--x-duration-base) var(--x-timing-base) 0.1s;
			}
			._3tz1C {
				color: var(--x-color-critical-accent);
			}
			.V72I1 {
				position: absolute !important;
				top: 0;
				clip: rect(1px, 1px, 1px, 1px) !important;
				overflow: hidden !important;
				height: 1px !important;
				width: 1px !important;
				padding: 0 !important;
				border: 0 !important;
			}
			._3bnbS {
				display: contents;
			}
			._2zIIX {
				--form-layout-group-spacing: var(--x-spacing-base);
				display: flex;
			}
			@media (min-width: 750px) {
				._2zIIX > * {
					flex: 1 1 0;
				}
				[dir="ltr"] ._2zIIX > * + * {
					margin-left: var(--form-layout-group-spacing);
				}
				._2zIIX > * + :dir(ltr) {
					margin-left: var(--form-layout-group-spacing);
				}
				[dir="rtl"] ._2zIIX > * + * {
					margin-right: var(--form-layout-group-spacing);
				}
				._2zIIX > * + :dir(rtl) {
					margin-right: var(--form-layout-group-spacing);
				}
				._2zIIX > * + * {
					margin-inline-start: var(--form-layout-group-spacing);
				}
			}
			@media (max-width: 749px) {
				._2zIIX {
					flex-direction: column;
				}
				._2zIIX > * + * {
					margin-top: var(--form-layout-group-spacing);
				}
			}
			._1UWZB {
				--form-layout-group-spacing: var(--x-spacing-tight1x);
			}
			._1vnYn {
				max-width: 100%;
			}
			._3BpAb {
				border: 1px solid var(--x-default-color-border);
			}
			._3xaNV {
				position: relative;
			}
			._3xaNV ._1vnYn {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
			@supports (object-fit: cover) {
				._3yN5j {
					object-fit: contain;
				}
				._3SeIN {
					object-fit: cover;
				}
			}
			._1Jrax {
				display: flex;
				height: 100%;
				align-items: flex-start;
				justify-content: center;
			}
			._2Zet_ {
				align-items: flex-end;
			}
			.ZXP_B {
				align-items: center;
			}
			._3Q55v {
				justify-content: flex-start;
			}
			.iZ_rd {
				justify-content: flex-end;
			}
			._3_xXQ {
				display: flex;
				align-items: flex-start;
				justify-content: center;
				width: 100%;
			}
			._3_xXQ > * {
				flex: 0 1 auto;
			}
			._3rTGt {
				justify-content: flex-start;
			}
			._14P7L {
				justify-content: flex-end;
			}
			.-Kbmc {
				-webkit-tap-highlight-color: transparent;
				-webkit-touch-callout: none;
				text-decoration: none;
				background-color: var(--x-color-interactive);
				color: var(--x-color-interactive-text);
				transition: color var(--x-link-transition-duration)
						var(--x-timing-base),
					background-color var(--x-link-transition-duration)
						var(--x-timing-base);
			}
			.-Kbmc:hover {
				--this-background-color: var(--x-color-interactive-hovered);
				--this-color: var(--x-color-interactive-text-hovered);
			}
			.-Kbmc:active,
			.-Kbmc:hover {
				background-color: var(--this-background-color);
				color: var(--this-color);
			}
			.-Kbmc:active {
				--this-background-color: var(--x-color-interactive-pressed);
				--this-color: var(--x-color-interactive-text-pressed);
			}
			._3PO8R {
				text-decoration: underline;
			}
			._3SInY:hover {
				background-color: var(--x-color1, var(--this-background-color));
				color: var(--x-color1-text, var(--this-color));
			}
			._3KXnD:hover {
				background-color: var(--x-color2, var(--this-background-color));
				color: var(--x-color2-text, var(--this-color));
			}
			._37wLu:active {
				background-color: var(--x-color1, var(--this-background-color));
				color: var(--x-color1-text, var(--this-color));
			}
			.A99KY:active {
				background-color: var(--x-color2, var(--this-background-color));
				color: var(--x-color2-text, var(--this-color));
			}
			.FB4Ef {
				display: grid;
				justify-content: start;
				grid-template:
					"radio gap label" auto/auto var(--x-spacing-tight1x)
					auto;
			}
			._1COav {
				-ms-grid-row: 1;
				-ms-grid-column: 1;
				grid-area: radio;
				position: relative;
			}
			._2wx5n {
				--input-border-color: var(--x-default-color-border);
				background-clip: padding-box;
				border: 1px var(--input-border-color) solid;
				border-radius: 50%;
				box-sizing: border-box;
				cursor: pointer;
				display: block;
				outline: none;
				transition: all var(--x-duration-fast) var(--x-timing-ease-out);
			}
			._2wx5n:before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				border-radius: 50%;
				display: block;
				pointer-events: none;
				box-shadow: 0 0 0 0 var(--input-checked-color);
				opacity: 0.3;
				transition: box-shadow var(--x-duration-fast)
					var(--x-timing-ease-out);
			}
			._2wx5n:active,
			._2wx5n:focus {
				border-color: var(--input-checked-color);
			}
			._2wx5n:active:before,
			._2wx5n:focus:before {
				box-shadow: 0 0 0 0.21428571428571427em
					var(--input-checked-color);
			}
			._2EXSb,
			._2EXSb:after,
			._2EXSb:before {
				width: var(--x-radio-size-base);
				height: var(--x-radio-size-base);
			}
			._3FMvC,
			._3FMvC:after,
			._3FMvC:before {
				margin-top: -2px;
				margin-bottom: -2px;
				margin-block: -2px;
				width: var(--x-radio-size-large);
				height: var(--x-radio-size-large);
			}
			.PeKfB:checked {
				border: 0.42857142857142855em var(--input-checked-color) solid;
			}
			._1sflY:after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				border-radius: 50%;
				display: block;
				pointer-events: none;
				background-clip: padding-box;
				border: 0.2857142857142857em solid transparent;
				background-color: var(--input-checked-color);
				transform: scale(0);
				transition: transform var(--x-duration-fast)
					var(--x-timing-ease-out);
			}
			._1sflY:checked:after {
				transform: scale(1);
			}
			._2vr9c {
				--input-checked-color: var(--x-color-interactive-text);
			}
			._3CE7d {
				--input-checked-color: var(--x-color-primary-action);
			}
			._32JJ_ {
				opacity: 0.7;
				cursor: default;
			}
			._32JJ_:before {
				display: none;
			}
			._32JJ_._3XPfv {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._32JJ_._2Nltm {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._32JJ_._3_AY9 {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			._1Fz1- {
				background-color: transparent;
			}
			._3XPfv {
				--x-default-color-accent: var(--x-color-surface-primary-accent);
				background-color: var(--x-color-surface-primary);
			}
			._2Nltm {
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
				background-color: var(--x-color-surface-secondary);
			}
			._3_AY9 {
				--x-default-color-accent: var(
					--x-color-surface-tertiary-accent
				);
				background-color: var(--x-color-surface-tertiary);
			}
			._3A0vy {
				--input-border-color: var(--x-default-color-border-emphasized);
			}
			._3EY6l {
				-ms-grid-row: 1;
				-ms-grid-column: 3;
				display: block;
				grid-area: label;
				cursor: pointer;
			}
			._1LGaz {
				cursor: default;
			}
			._3lyEW {
				--selector-width: 2.857142857142857em;
				position: relative;
			}
			._34-rS {
				transition: top var(--x-duration-base) var(--x-timing-base);
			}
			[dir="ltr"] ._3M3ds {
				left: 0.8571428571428571em;
			}
			._3M3ds:dir(ltr) {
				left: 0.8571428571428571em;
			}
			[dir="rtl"] ._3M3ds {
				right: 0.8571428571428571em;
			}
			._3M3ds:dir(rtl) {
				right: 0.8571428571428571em;
			}
			._3M3ds {
				position: absolute;
				pointer-events: none;
				top: 0.39999999999999997em;
				inset-inline-start: 0.8571428571428571em;
				-webkit-user-select: none;
				user-select: none;
				max-width: calc(
					100% - 1.85714em -
						var(--selector-width, 2.857142857142857em)
				);
			}
			._3M3ds._33pNR {
				--x-default-color-text-subdued: var(
					--x-color-surface-primary-text-subdued
				);
			}
			._3M3ds._1P32H {
				--x-default-color-text-subdued: var(
					--x-color-surface-secondary-text-subdued
				);
			}
			._3M3ds._14HNF {
				--x-default-color-text-subdued: var(
					--x-color-surface-tertiary-text-subdued
				);
			}
			._2IEnS {
				display: block;
				margin-bottom: var(--x-spacing-tight4x);
			}
			._2CTw3 {
				top: 1.0714285714285714em;
			}
			[dir="ltr"] .lR9fE {
				padding-left: 0.8571428571428571em;
				padding-right: var(--selector-width, 2.857142857142857em);
			}
			.lR9fE:dir(ltr) {
				padding-left: 0.8571428571428571em;
				padding-right: var(--selector-width, 2.857142857142857em);
			}
			[dir="rtl"] .lR9fE {
				padding-right: 0.8571428571428571em;
				padding-left: var(--selector-width, 2.857142857142857em);
			}
			.lR9fE:dir(rtl) {
				padding-right: 0.8571428571428571em;
				padding-left: var(--selector-width, 2.857142857142857em);
			}
			.lR9fE {
				-webkit-tap-highlight-color: transparent;
				border: 0 solid transparent;
				border-radius: var(
					--x-select-border-radius,
					var(
						--x-control-border-radius,
						var(--x-global-border-radius)
					)
				);
				font-size: var(--x-typography-size-default);
				line-height: inherit;
				outline: none;
				padding-top: 1.5em;
				padding-bottom: 0.42857142857142855em;
				padding-block: 1.5em 0.42857142857142855em;
				padding-inline: 0.8571428571428571em
					var(--selector-width, 2.857142857142857em);
				min-height: 3.357142857142857em;
				transition: box-shadow var(--x-duration-base)
						var(--x-timing-base),
					border var(--x-duration-base) var(--x-timing-base);
				text-transform: var(--x-global-typography-letter-case);
				letter-spacing: var(--x-global-typography-kerning);
				width: 100%;
				white-space: nowrap;
			}
			.lR9fE::-ms-expand {
				display: none;
			}
			.lR9fE:-moz-focusring {
				color: transparent;
				text-shadow: 0 0 0 var(--moz-focusring-color);
			}
			@supports (-moz-appearance: meterbar) {
				.lR9fE {
					text-indent: -2px;
				}
			}
			._2x_pu {
				padding-top: 1em;
				padding-bottom: 0.9285714285714286em;
			}
			._1Z7b3 {
				min-height: auto;
				padding-top: 0;
				padding-bottom: 0;
			}
			._1KJAM {
				--moz-focusring-color: var(--x-default-color-text-emphasized);
				background-color: transparent;
			}
			._3dHSO {
				--moz-focusring-color: var(
					--x-color-surface-primary-text-emphasized
				);
				--x-default-color-accent: var(--x-color-surface-primary-accent);
				color: var(--x-color-surface-primary-text-emphasized);
				background-color: var(--x-color-surface-primary);
			}
			._3dHSO + .cg791 {
				border-color: var(--x-color-surface-primary-border);
				color: var(--x-color-surface-primary-text-subdued);
			}
			._3dHSO + .cg791.fig3N {
				border-color: var(--x-color-surface-primary-border-emphasized);
			}
			._1OUiC {
				--moz-focusring-color: var(
					--x-color-surface-secondary-text-emphasized
				);
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
				color: var(--x-color-surface-secondary-text-emphasized);
				background-color: var(--x-color-surface-secondary);
			}
			._1OUiC + .cg791 {
				border-color: var(--x-color-surface-secondary-border);
				color: var(--x-color-surface-secondary-text-subdued);
			}
			._1OUiC + .cg791.fig3N {
				border-color: var(
					--x-color-surface-secondary-border-emphasized
				);
			}
			._1WCXA {
				--moz-focusring-color: var(
					--x-color-surface-tertiary-text-emphasized
				);
				--x-default-color-accent: var(
					--x-color-surface-tertiary-accent
				);
				color: var(--x-color-surface-tertiary-text-emphasized);
				background-color: var(--x-color-surface-tertiary);
			}
			._1WCXA + .cg791 {
				border-color: var(--x-color-surface-tertiary-border);
				color: var(--x-color-surface-tertiary-text-subdued);
			}
			._1WCXA + .cg791.fig3N {
				border-color: var(--x-color-surface-tertiary-border-emphasized);
			}
			.qiuUK.sWGEL:focus {
				box-shadow: 0 0 0 2px var(--x-color-interactive-text);
			}
			.qiuUK.sWGEL._1FUqZ,
			.qiuUK.sWGEL._1FUqZ:focus {
				box-shadow: 0 0 0 2px var(--x-color-critical-accent);
			}
			.qiuUK._1eomO:focus {
				box-shadow: 0 2px 0 0 var(--x-color-interactive-text);
			}
			.qiuUK._1eomO._1FUqZ,
			.qiuUK._1eomO._1FUqZ:focus {
				box-shadow: 0 2px 0 0 var(--x-color-critical-accent);
			}
			[dir="ltr"] ._23HvW {
				padding-left: 0.7857142857142857em;
			}
			._23HvW:dir(ltr) {
				padding-left: 0.7857142857142857em;
			}
			[dir="rtl"] ._23HvW {
				padding-right: 0.7857142857142857em;
			}
			._23HvW:dir(rtl) {
				padding-right: 0.7857142857142857em;
			}
			._23HvW {
				border-width: 1px;
				border-color: var(--x-default-color-border);
				padding-inline-start: 0.7857142857142857em;
			}
			._23HvW.sWGEL:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 0 0 0 1px var(--x-color-interactive-text);
			}
			._23HvW.sWGEL._1FUqZ,
			._23HvW.sWGEL._1FUqZ:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 0 0 0 1px var(--x-color-critical-accent);
			}
			._23HvW._1eomO:focus {
				border-bottom-color: var(--x-color-interactive-text);
				box-shadow: 0 1px 0 0 var(--x-color-interactive-text);
			}
			._23HvW._1eomO._1FUqZ,
			._23HvW._1eomO._1FUqZ:focus {
				border-bottom-color: var(--x-color-critical-accent);
				box-shadow: 0 1px 0 0 var(--x-color-critical-accent);
			}
			.ve1KA {
				border-width: 0 0 1px;
				border-color: var(--x-default-color-border);
			}
			.ve1KA.sWGEL:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 1px 0 0 1px var(--x-color-interactive-text),
					-1px 0 0 1px var(--x-color-interactive-text),
					1px -1px 0 1px var(--x-color-interactive-text),
					-1px -1px 0 1px var(--x-color-interactive-text);
			}
			.ve1KA.sWGEL._1FUqZ,
			.ve1KA.sWGEL._1FUqZ:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 1px 0 0 1px var(--x-color-critical-accent),
					-1px 0 0 1px var(--x-color-critical-accent),
					1px -1px 0 1px var(--x-color-critical-accent),
					-1px -1px 0 1px var(--x-color-critical-accent);
			}
			.ve1KA._1eomO:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 0 1px 0 0 var(--x-color-interactive-text);
			}
			.ve1KA._1eomO._1FUqZ,
			.ve1KA._1eomO._1FUqZ:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 0 1px 0 0 var(--x-color-critical-accent);
			}
			._3jISN {
				border-color: var(--x-default-color-border-emphasized);
			}
			._1JqPr,
			._1JqPr + .cg791 {
				opacity: 0.7;
			}
			._1JqPr._3dHSO {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._1JqPr._1OUiC {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._1JqPr._1WCXA {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			._18X-e,
			._18X-e + .cg791 {
				opacity: 0.7;
			}
			._18X-e._3dHSO {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._18X-e._1OUiC {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._18X-e._1WCXA {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			[dir="ltr"] .cg791 {
				right: 1px;
			}
			.cg791:dir(ltr) {
				right: 1px;
			}
			[dir="rtl"] .cg791 {
				left: 1px;
			}
			.cg791:dir(rtl) {
				left: 1px;
			}
			.cg791 {
				position: absolute;
				top: 50%;
				inset-inline-end: 1px;
				display: flex;
				align-items: center;
				justify-content: center;
				pointer-events: none;
				width: var(--selector-width, 2.857142857142857em);
				height: 43%;
				transform: translateY(-50%);
			}
			[dir="ltr"] ._3RVyp {
				border-left-width: 0.1rem;
			}
			._3RVyp:dir(ltr) {
				border-left-width: 0.1rem;
			}
			[dir="rtl"] ._3RVyp {
				border-right-width: 0.1rem;
			}
			._3RVyp:dir(rtl) {
				border-right-width: 0.1rem;
			}
			[dir="ltr"] ._3RVyp {
				border-left-style: solid;
			}
			._3RVyp:dir(ltr) {
				border-left-style: solid;
			}
			[dir="rtl"] ._3RVyp {
				border-right-style: solid;
			}
			._3RVyp:dir(rtl) {
				border-right-style: solid;
			}
			._3RVyp {
				border-inline-start-width: 0.1rem;
				border-inline-start-style: solid;
			}
			._10g9F {
				padding: 0 0.8571428571428571em;
			}
			._2AqiW {
				font-size: var(--x-typography-size-default);
				text-transform: var(--x-global-typography-letter-case);
				letter-spacing: var(--x-global-typography-kerning);
			}
			._2BWL1 {
				color: var(
					--x-default-color-text-subdued,
					var(--x-default-color-text, inherit)
				);
			}
			._1jmYs {
				--this-font-weight: var(--x-typography-primary-weight-bold);
				font-weight: var(--this-font-weight);
				color: var(
					--x-default-color-text-emphasized,
					var(--x-default-color-text, inherit)
				);
			}
			._1blxA {
				color: var(--x-default-color-accent);
			}
			._1tABw {
				color: var(--x-color-success-accent);
			}
			._1-e86 {
				color: var(--x-color-warning-accent);
			}
			._9bcWJ {
				color: var(--x-color-critical-accent);
			}
			._1Rmst {
				--this-font-size: var(--x-typography-size-xsmall);
			}
			._1Rmst,
			.fuf0U {
				font-size: var(--this-font-size);
			}
			.fuf0U {
				--this-font-size: var(--x-typography-size-small);
			}
			.N1f9r {
				--this-font-size: var(--x-typography-size-medium);
			}
			.N1f9r,
			.s5OcN {
				font-size: var(--this-font-size);
			}
			.s5OcN {
				--this-font-size: var(--x-typography-size-large);
			}
			._3cD2S {
				--this-font-size: var(--x-typography-size-xlarge);
				font-size: var(--this-font-size);
			}
			._2PQCJ {
				font-feature-settings: "kern" off;
				font-variant: none;
				text-decoration: none;
			}
			._1WSCn {
				display: block;
			}
			._2MU_X {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			._9gvvC {
				border: 0 solid var(--x-default-color-border);
			}
			.lWe1z {
				height: 0;
				width: 100%;
			}
			._2M8Wt {
				height: 100%;
				width: 0;
			}
			._1BPaF {
				font-size: var(--x-typography-size-default);
				line-height: var(--x-global-typography-line-size-large);
				text-transform: var(--x-global-typography-letter-case);
				letter-spacing: var(--x-global-typography-kerning);
			}
			._1ZTfI {
				color: var(
					--x-default-color-text-subdued,
					var(--x-default-color-text, inherit)
				);
			}
			._2ADFD {
				--this-font-weight: var(--x-typography-primary-weight-bold);
				font-weight: var(--this-font-weight);
				color: var(
					--x-default-color-text-emphasized,
					var(--x-default-color-text, inherit)
				);
			}
			.XhVJ1 {
				color: var(--x-default-color-accent);
			}
			.ao1kt {
				color: var(--x-color-success-accent);
			}
			._13B7R {
				color: var(--x-color-warning-accent);
			}
			._1cDwQ {
				color: var(--x-color-critical-accent);
			}
			._2oAgf {
				--this-font-size: var(--x-typography-size-small);
			}
			._2oAgf,
			.dqjqs {
				font-size: var(--this-font-size);
			}
			.dqjqs {
				--this-font-size: var(--x-typography-size-medium);
			}
			._2dggP {
				--this-font-size: var(--x-typography-size-large);
			}
			._2_2yY,
			._2dggP {
				font-size: var(--this-font-size);
			}
			._2_2yY {
				--this-font-size: var(--x-typography-size-xlarge);
			}
			._3s7Q- {
				position: relative;
			}
			._1dc2V {
				-webkit-tap-highlight-color: transparent;
				border: 0 solid transparent;
				border-radius: var(
					--x-text-field-border-radius,
					var(
						--x-control-border-radius,
						var(--x-global-border-radius)
					)
				);
				font-size: var(--x-typography-size-default);
				outline: none;
				padding-left: 0.8571428571428571em;
				padding-right: 0.8571428571428571em;
				padding-inline: 0.8571428571428571em;
				min-height: 3.357142857142857em;
				transition: box-shadow var(--x-duration-base)
						var(--x-timing-base),
					border var(--x-duration-base) var(--x-timing-base);
				text-transform: var(--x-global-typography-letter-case);
				letter-spacing: var(--x-global-typography-kerning);
				width: 100%;
			}
			._1dc2V::placeholder {
				color: var(--placeholder-color);
				opacity: 1;
			}
			._1dc2V:invalid {
				box-shadow: none;
			}
			._1Rs6F {
				transition: all var(--x-duration-base) var(--x-timing-base);
				padding-top: 1em;
			}
			[dir="ltr"] ._2acDf {
				padding-right: 3.142857142857143em;
			}
			._2acDf:dir(ltr) {
				padding-right: 3.142857142857143em;
			}
			[dir="rtl"] ._2acDf {
				padding-left: 3.142857142857143em;
			}
			._2acDf:dir(rtl) {
				padding-left: 3.142857142857143em;
			}
			._2acDf {
				padding-inline-end: 3.142857142857143em;
			}
			._3gZtN {
				--placeholder-color: var(--x-default-color-text-subdued);
				background-color: transparent;
			}
			.qhnvu {
				--placeholder-color: var(
					--x-color-surface-primary-text-subdued
				);
				--x-default-color-text-subdued: var(
					--x-color-surface-primary-text-subdued
				);
				--x-default-color-accent: var(--x-color-surface-primary-accent);
				color: var(--x-color-surface-primary-text-emphasized);
				background-color: var(--x-color-surface-primary);
			}
			.qhnvu + ._3bX5W {
				--x-default-color-text-subdued: var(
					--x-color-surface-primary-text-subdued
				);
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
			}
			._5iVPR {
				--placeholder-color: var(
					--x-color-surface-secondary-text-subdued
				);
				color: var(--x-color-surface-secondary-text-emphasized);
				background-color: var(--x-color-surface-secondary);
			}
			._5iVPR,
			._5iVPR + ._3bX5W {
				--x-default-color-text-subdued: var(
					--x-color-surface-secondary-text-subdued
				);
				--x-default-color-accent: var(
					--x-color-surface-secondary-accent
				);
			}
			.WSXXQ {
				--placeholder-color: var(
					--x-color-surface-tertiary-text-subdued
				);
				color: var(--x-color-surface-tertiary-text-emphasized);
				background-color: var(--x-color-surface-tertiary);
			}
			.WSXXQ,
			.WSXXQ + ._3bX5W {
				--x-default-color-text-subdued: var(
					--x-color-surface-tertiary-text-subdued
				);
				--x-default-color-accent: var(
					--x-color-surface-tertiary-accent
				);
			}
			._1egrQ._1-o_t:focus {
				box-shadow: 0 0 0 2px var(--x-color-interactive-text);
			}
			._1egrQ._1-o_t.J4qPU,
			._1egrQ._1-o_t.J4qPU:focus {
				box-shadow: 0 0 0 2px var(--x-color-critical-accent);
			}
			._1egrQ._3RQDc:focus {
				box-shadow: 0 2px 0 0 var(--x-color-interactive-text);
			}
			._1egrQ._3RQDc.J4qPU,
			._1egrQ._3RQDc.J4qPU:focus {
				box-shadow: 0 2px 0 0 var(--x-color-critical-accent);
			}
			[dir="ltr"] ._2lSoF {
				padding-left: 0.7857142857142857em;
			}
			._2lSoF:dir(ltr) {
				padding-left: 0.7857142857142857em;
			}
			[dir="rtl"] ._2lSoF {
				padding-right: 0.7857142857142857em;
			}
			._2lSoF:dir(rtl) {
				padding-right: 0.7857142857142857em;
			}
			._2lSoF {
				border-width: 1px;
				border-color: var(--x-default-color-border);
				padding-inline-start: 0.7857142857142857em;
			}
			._2lSoF._1-o_t:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 0 0 0 1px var(--x-color-interactive-text);
			}
			._2lSoF._1-o_t.J4qPU,
			._2lSoF._1-o_t.J4qPU:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 0 0 0 1px var(--x-color-critical-accent);
			}
			._2lSoF._3RQDc:focus {
				border-bottom-color: var(--x-color-interactive-text);
				box-shadow: 0 1px 0 0 var(--x-color-interactive-text);
			}
			._2lSoF._3RQDc.J4qPU,
			._2lSoF._3RQDc.J4qPU:focus {
				border-bottom-color: var(--x-color-critical-accent);
				box-shadow: 0 1px 0 0 var(--x-color-critical-accent);
			}
			._2oDim {
				border-width: 0 0 1px;
				border-color: var(--x-default-color-border);
			}
			._2oDim._1-o_t:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 1px 0 0 1px var(--x-color-interactive-text),
					-1px 0 0 1px var(--x-color-interactive-text),
					1px -1px 0 1px var(--x-color-interactive-text),
					-1px -1px 0 1px var(--x-color-interactive-text);
			}
			._2oDim._1-o_t.J4qPU,
			._2oDim._1-o_t.J4qPU:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 1px 0 0 1px var(--x-color-critical-accent),
					-1px 0 0 1px var(--x-color-critical-accent),
					1px -1px 0 1px var(--x-color-critical-accent),
					-1px -1px 0 1px var(--x-color-critical-accent);
			}
			._2oDim._3RQDc:focus {
				border-color: var(--x-color-interactive-text);
				box-shadow: 0 1px 0 0 var(--x-color-interactive-text);
			}
			._2oDim._3RQDc.J4qPU,
			._2oDim._3RQDc.J4qPU:focus {
				border-color: var(--x-color-critical-accent);
				box-shadow: 0 1px 0 0 var(--x-color-critical-accent);
			}
			._2iLwH {
				border-color: var(--x-default-color-border-emphasized);
			}
			[dir="ltr"] ._3bX5W {
				right: var(--x-spacing-base);
			}
			._3bX5W:dir(ltr) {
				right: var(--x-spacing-base);
			}
			[dir="rtl"] ._3bX5W {
				left: var(--x-spacing-base);
			}
			._3bX5W:dir(rtl) {
				left: var(--x-spacing-base);
			}
			._3bX5W {
				position: absolute;
				top: 50%;
				inset-inline-end: var(--x-spacing-base);
				transform: translateY(-50%);
				z-index: 1;
			}
			._1qWz4 {
				padding: 0 0.8571428571428571em;
			}
			._1joKF {
				opacity: 0.7;
			}
			._1joKF.qhnvu {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._1joKF._5iVPR {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._1joKF.WSXXQ {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			._3QOHm {
				opacity: 0.7;
			}
			._3QOHm.qhnvu {
				background-color: var(--x-color-surface-primary-disabled);
			}
			._3QOHm._5iVPR {
				background-color: var(--x-color-surface-secondary-disabled);
			}
			._3QOHm.WSXXQ {
				background-color: var(--x-color-surface-tertiary-disabled);
			}
			._1IVTx {
				position: relative;
			}
			._2FQk3 {
				-webkit-tap-highlight-color: transparent;
				display: block;
				padding: 0.9285714285714286em 0.9285714285714286em;
				margin: -0.9285714285714286em -0.9285714285714286em;
			}
			._2w7hZ {
				transform: scale(0.8);
				transform-origin: center 120%;
				display: inline-block;
				color: var(--color--white);
				max-width: 12.857142857142858em;
				padding: var(--x-spacing-tight);
				opacity: 0;
				transition: transform var(--x-duration-base)
						var(--x-timing-spring),
					opacity var(--x-duration-base) var(--x-timing-spring);
			}
			._2w7hZ.rl6Z5 {
				transform: scale(1) perspective(1px);
				opacity: 1;
			}
			._2w7hZ._2HdfB,
			._2w7hZ._3n63n {
				pointer-events: none;
			}
			._2w7hZ:before {
				content: "";
				position: absolute;
				z-index: -1;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				display: block;
				background-color: #333;
			}
			._2WhUD {
				position: absolute;
				top: 100%;
				left: 50%;
				right: 50%;
				width: 0;
				border: 0.42857142857142855em solid transparent;
				border-top-color: #333;
			}
			[dir="rtl"] ._2WhUD {
				transform: translate(50%);
			}
			._2WhUD:dir(rtl) {
				transform: translate(50%);
			}
			[dir="ltr"] ._2WhUD {
				transform: translate(-50%);
			}
			._2WhUD:dir(ltr) {
				transform: translate(-50%);
			}
			._1pjh1 {
				color: var(--x-color-surface-primary-text);
			}
			._1pjh1:before {
				background-color: var(--x-color-surface-primary);
			}
			._1pjh1 ._2WhUD {
				border-top-color: var(--x-color-surface-primary);
			}
			._3KrUy {
				color: var(--x-color-surface-secondary-text);
			}
			._3KrUy:before {
				background-color: var(--x-color-surface-secondary);
			}
			._3KrUy ._2WhUD {
				border-top-color: var(--x-color-surface-secondary);
			}
			._88WRn {
				color: var(--x-color-surface-tertiary-text);
			}
			._88WRn:before {
				background-color: var(--x-color-surface-tertiary);
			}
			._88WRn ._2WhUD {
				border-top-color: var(--x-color-surface-tertiary);
			}
			._3TUA9 ._2WhUD,
			._3TUA9:before {
				opacity: 0.9;
			}
			._2NVF2:before ._2WhUD,
			._2NVF2:before:before {
				opacity: 1;
			}
			._2bnOu:before {
				border-radius: var(--x-border-radius-none);
			}
			.G6x3I:before {
				border-radius: var(--x-border-radius-tight);
			}
			._14cA9:before {
				border-radius: var(--x-border-radius-base);
			}
			._1y-DK:before {
				border-radius: var(--x-border-radius-fully-rounded);
			}
			._2XQQG {
				position: absolute;
				z-index: 1000;
				top: 0;
				left: 0;
			}
			._3SpZ0 {
				color: var(--x-default-color-text);
			}
			._3JThB {
				position: relative;
			}
			[dir="ltr"] ._2Bfbm {
				left: 0.8571428571428571em;
			}
			._2Bfbm:dir(ltr) {
				left: 0.8571428571428571em;
			}
			[dir="rtl"] ._2Bfbm {
				right: 0.8571428571428571em;
			}
			._2Bfbm:dir(rtl) {
				right: 0.8571428571428571em;
			}
			._2Bfbm {
				position: absolute;
				pointer-events: none;
				top: 0.39999999999999997em;
				inset-inline-start: 0.8571428571428571em;
				transition: all var(--x-duration-base) var(--x-timing-base);
				-webkit-user-select: none;
				user-select: none;
				opacity: 0;
				z-index: 1;
				max-width: calc(100% - 1.85714em);
			}
			._2Bfbm.ZLKLR {
				--x-default-color-text-subdued: var(
					--x-color-surface-primary-text-subdued
				);
			}
			._2Bfbm._3ryHA {
				--x-default-color-text-subdued: var(
					--x-color-surface-secondary-text-subdued
				);
			}
			._2Bfbm._1I2oR {
				--x-default-color-text-subdued: var(
					--x-color-surface-tertiary-text-subdued
				);
			}
			.mec-q {
				z-index: inherit;
			}
			._3_Kgi {
				display: block;
				margin-bottom: var(--x-spacing-tight4x);
			}
			._2f2Ya ._3_ZEI {
				opacity: 1;
			}
			[dir="ltr"] .eEmMB {
				margin-left: calc(var(--x-spacing-base) * -1);
			}
			.eEmMB:dir(ltr) {
				margin-left: calc(var(--x-spacing-base) * -1);
			}
			[dir="rtl"] .eEmMB {
				margin-right: calc(var(--x-spacing-base) * -1);
			}
			.eEmMB:dir(rtl) {
				margin-right: calc(var(--x-spacing-base) * -1);
			}
			.eEmMB {
				display: flex;
				flex-wrap: wrap;
				margin-top: calc(var(--x-spacing-base) * -1);
				margin-inline-start: calc(var(--x-spacing-base) * -1);
			}
			[dir="ltr"] .eEmMB > * {
				padding-left: var(--x-spacing-base);
			}
			.eEmMB > :dir(ltr) {
				padding-left: var(--x-spacing-base);
			}
			[dir="rtl"] .eEmMB > * {
				padding-right: var(--x-spacing-base);
			}
			.eEmMB > :dir(rtl) {
				padding-right: var(--x-spacing-base);
			}
			.eEmMB > * {
				min-width: var(--tile-width, 0);
				max-width: 100%;
				padding-top: var(--x-spacing-base);
				padding-inline-start: var(--x-spacing-base);
				flex: 0 0
					calc(
						(
								var(--tiles-breakpoint, 0) +
									var(--x-spacing-base) - 100%
							) * 999
					);
			}
			[dir="ltr"] ._3kQxH {
				margin-left: 0;
			}
			._3kQxH:dir(ltr) {
				margin-left: 0;
			}
			[dir="rtl"] ._3kQxH {
				margin-right: 0;
			}
			._3kQxH:dir(rtl) {
				margin-right: 0;
			}
			._3kQxH {
				margin-top: 0;
				margin-inline-start: 0;
			}
			[dir="ltr"] ._3kQxH > * {
				padding-left: 0;
			}
			._3kQxH > :dir(ltr) {
				padding-left: 0;
			}
			[dir="rtl"] ._3kQxH > * {
				padding-right: 0;
			}
			._3kQxH > :dir(rtl) {
				padding-right: 0;
			}
			._3kQxH > * {
				padding-top: 0;
				padding-inline-start: 0;
				flex-basis: calc((var(--tiles-breakpoint, 0) - 100%) * 999);
			}
			[dir="ltr"] ._2C1-t {
				margin-left: calc(var(--x-spacing-tight4x) * -1);
			}
			._2C1-t:dir(ltr) {
				margin-left: calc(var(--x-spacing-tight4x) * -1);
			}
			[dir="rtl"] ._2C1-t {
				margin-right: calc(var(--x-spacing-tight4x) * -1);
			}
			._2C1-t:dir(rtl) {
				margin-right: calc(var(--x-spacing-tight4x) * -1);
			}
			._2C1-t {
				margin-top: calc(var(--x-spacing-tight4x) * -1);
				margin-inline-start: calc(var(--x-spacing-tight4x) * -1);
			}
			[dir="ltr"] ._2C1-t > * {
				padding-left: var(--x-spacing-tight4x);
			}
			._2C1-t > :dir(ltr) {
				padding-left: var(--x-spacing-tight4x);
			}
			[dir="rtl"] ._2C1-t > * {
				padding-right: var(--x-spacing-tight4x);
			}
			._2C1-t > :dir(rtl) {
				padding-right: var(--x-spacing-tight4x);
			}
			._2C1-t > * {
				padding-top: var(--x-spacing-tight4x);
				padding-inline-start: var(--x-spacing-tight4x);
				flex-basis: calc(
					(
							var(--tiles-breakpoint, 0) +
								var(--x-spacing-tight4x) - 100%
						) * 999
				);
			}
			[dir="ltr"] ._3bsZ_ {
				margin-left: calc(var(--x-spacing-tight1x) * -1);
			}
			._3bsZ_:dir(ltr) {
				margin-left: calc(var(--x-spacing-tight1x) * -1);
			}
			[dir="rtl"] ._3bsZ_ {
				margin-right: calc(var(--x-spacing-tight1x) * -1);
			}
			._3bsZ_:dir(rtl) {
				margin-right: calc(var(--x-spacing-tight1x) * -1);
			}
			._3bsZ_ {
				margin-top: calc(var(--x-spacing-tight1x) * -1);
				margin-inline-start: calc(var(--x-spacing-tight1x) * -1);
			}
			[dir="ltr"] ._3bsZ_ > * {
				padding-left: var(--x-spacing-tight1x);
			}
			._3bsZ_ > :dir(ltr) {
				padding-left: var(--x-spacing-tight1x);
			}
			[dir="rtl"] ._3bsZ_ > * {
				padding-right: var(--x-spacing-tight1x);
			}
			._3bsZ_ > :dir(rtl) {
				padding-right: var(--x-spacing-tight1x);
			}
			._3bsZ_ > * {
				padding-top: var(--x-spacing-tight1x);
				padding-inline-start: var(--x-spacing-tight1x);
				flex-basis: calc(
					(
							var(--tiles-breakpoint, 0) +
								var(--x-spacing-tight1x) - 100%
						) * 999
				);
			}
			[dir="ltr"] ._21jHh {
				margin-left: calc(var(--x-spacing-loose1x) * -1);
			}
			._21jHh:dir(ltr) {
				margin-left: calc(var(--x-spacing-loose1x) * -1);
			}
			[dir="rtl"] ._21jHh {
				margin-right: calc(var(--x-spacing-loose1x) * -1);
			}
			._21jHh:dir(rtl) {
				margin-right: calc(var(--x-spacing-loose1x) * -1);
			}
			._21jHh {
				margin-top: calc(var(--x-spacing-loose1x) * -1);
				margin-inline-start: calc(var(--x-spacing-loose1x) * -1);
			}
			[dir="ltr"] ._21jHh > * {
				padding-left: var(--x-spacing-loose1x);
			}
			._21jHh > :dir(ltr) {
				padding-left: var(--x-spacing-loose1x);
			}
			[dir="rtl"] ._21jHh > * {
				padding-right: var(--x-spacing-loose1x);
			}
			._21jHh > :dir(rtl) {
				padding-right: var(--x-spacing-loose1x);
			}
			._21jHh > * {
				padding-top: var(--x-spacing-loose1x);
				padding-inline-start: var(--x-spacing-loose1x);
				flex-basis: calc(
					(
							var(--tiles-breakpoint, 0) +
								var(--x-spacing-loose1x) - 100%
						) * 999
				);
			}
			[dir="ltr"] .EpWl9 {
				margin-left: calc(var(--x-spacing-loose4x) * -1);
			}
			.EpWl9:dir(ltr) {
				margin-left: calc(var(--x-spacing-loose4x) * -1);
			}
			[dir="rtl"] .EpWl9 {
				margin-right: calc(var(--x-spacing-loose4x) * -1);
			}
			.EpWl9:dir(rtl) {
				margin-right: calc(var(--x-spacing-loose4x) * -1);
			}
			.EpWl9 {
				margin-top: calc(var(--x-spacing-loose4x) * -1);
				margin-inline-start: calc(var(--x-spacing-loose4x) * -1);
			}
			[dir="ltr"] .EpWl9 > * {
				padding-left: var(--x-spacing-loose4x);
			}
			.EpWl9 > :dir(ltr) {
				padding-left: var(--x-spacing-loose4x);
			}
			[dir="rtl"] .EpWl9 > * {
				padding-right: var(--x-spacing-loose4x);
			}
			.EpWl9 > :dir(rtl) {
				padding-right: var(--x-spacing-loose4x);
			}
			.EpWl9 > * {
				padding-top: var(--x-spacing-loose4x);
				padding-inline-start: var(--x-spacing-loose4x);
				flex-basis: calc(
					(
							var(--tiles-breakpoint, 0) +
								var(--x-spacing-loose4x) - 100%
						) * 999
				);
			}
			._25a7J {
				align-items: flex-start;
			}
			._1YbN6 {
				align-items: center;
			}
			.TXO12 {
				align-items: flex-end;
			}
			.x-SAO {
				align-items: baseline;
			}
			._3S5Mb > * {
				flex-grow: 1;
			}
			._31tbC > * {
				flex-basis: 0;
			}
			._1_8iO {
				--x-default-color-subdued: var(--x-color-canvas-subdued);
				--x-default-color-text: var(--x-color-canvas-text);
				--x-default-color-text-subdued: var(
					--x-color-canvas-text-subdued
				);
				--x-default-color-text-emphasized: var(
					--x-color-canvas-text-emphasized
				);
				--x-default-color-border: var(--x-color-canvas-border);
				--x-default-color-border-emphasized: var(
					--x-color-canvas-border-emphasized
				);
				--x-default-color-accent: var(--x-color-canvas-accent);
				--x-default-color-disabled: var(--x-color-canvas-disabled);
				background: var(--x-color-canvas);
				color: var(--x-default-color-text);
				font-size: var(--x-typography-size-default);
				font-family: var(--x-typography-primary-fonts);
				font-weight: var(--x-typography-primary-weight-base);
				line-height: var(--x-global-typography-line-size-default);
				text-transform: var(--x-global-typography-letter-case);
				touch-action: manipulation;
			}
			._coop-extension-dummy-block {
				display: flex;
				justify-content: flex-end;
			}
			._coop-extension-dummy-block > span,
			._coop-extension-dummy-block > strong {
				width: 50px !important;
				height: 12px;
				background-color: rgba(0, 0, 0, 0.2);
				border-radius: 10px;
				display: block;
				color: transparent;
			}
		</style>
		<!--[if gte IE 9]><!-->
		<link
			rel="stylesheet"
			href="//cdn.shopify.com/app/services/55359111341/assets/120794906797/post_purchase_stylesheet/v2-ltr-edge-6cf0d0393005086f864bba4ca9b8def6-21"
			media="all"
		/>
	</head>
	<body>
		<div class="checkout-zero" style="height: 60px"></div>
		<div class="step" data-step="post_purchase">
			<div
				data-serialized-id="post-purchase-page-data"
			></div>
			<div data-id="post-purchase-page-root">
`;

// const RENDER_EXTENSION_DATA_SERIALIZED_VALUE = `data-serialized-value='{"script_url":"https:\/\/f10f64bc961f.ngrok.io\/assets\/extension.js","app_id":"5102155","input_data":{"extensionPoint":"Checkout::PostPurchase::Render","initialPurchase":{"referenceId":"67aba595f2b4c55df0996d6b0c8d8f31","customerId":4500464206001,"destinationCountryCode":null,"totalPriceSet":{"shopMoney":{"amount":"1.00","currencyCode":"USD"},"presentmentMoney":{"amount":"1.00","currencyCode":"USD"}},"lineItems":[{"product":{"id":6114407219377,"metafields":[],"title":"5 Panel Camp Cap","variant":{"id":37655828103345,"metafields":[],"title":"Heather Green"}},"quantity":1,"totalPriceSet":{"shopMoney":{"amount":"1.00","currencyCode":"USD"},"presentmentMoney":{"amount":"1.00","currencyCode":"USD"}}}]},"locale":"en","shop":{"id":51745095857,"domain":"coop-app-test-store.myshopify.com","metafields":[]},"version":"unstable","token":"eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaG9waWZ5Iiwic3ViIjoiNjdhYmE1OTVmMmI0YzU1ZGYwOTk2ZDZiMGM4ZDhmMzEiLCJpbnB1dF9kYXRhIjp7ImV4dGVuc2lvblBvaW50IjoiQ2hlY2tvdXQ6OlBvc3RQdXJjaGFzZTo6UmVuZGVyIiwiaW5pdGlhbFB1cmNoYXNlIjp7InJlZmVyZW5jZUlkIjoiNjdhYmE1OTVmMmI0YzU1ZGYwOTk2ZDZiMGM4ZDhmMzEiLCJjdXN0b21lcklkIjo0NTAwNDY0MjA2MDAxLCJkZXN0aW5hdGlvbkNvdW50cnlDb2RlIjpudWxsLCJ0b3RhbFByaWNlU2V0Ijp7InNob3BNb25leSI6eyJhbW91bnQiOiIxLjAwIiwiY3VycmVuY3lDb2RlIjoiVVNEIn0sInByZXNlbnRtZW50TW9uZXkiOnsiYW1vdW50IjoiMS4wMCIsImN1cnJlbmN5Q29kZSI6IlVTRCJ9fSwibGluZUl0ZW1zIjpbeyJwcm9kdWN0Ijp7ImlkIjo2MTE0NDA3MjE5Mzc3LCJtZXRhZmllbGRzIjpbXSwidGl0bGUiOiI1IFBhbmVsIENhbXAgQ2FwIiwidmFyaWFudCI6eyJpZCI6Mzc2NTU4MjgxMDMzNDUsIm1ldGFmaWVsZHMiOltdLCJ0aXRsZSI6IkhlYXRoZXIgR3JlZW4ifX0sInF1YW50aXR5IjoxLCJ0b3RhbFByaWNlU2V0Ijp7InNob3BNb25leSI6eyJhbW91bnQiOiIxLjAwIiwiY3VycmVuY3lDb2RlIjoiVVNEIn0sInByZXNlbnRtZW50TW9uZXkiOnsiYW1vdW50IjoiMS4wMCIsImN1cnJlbmN5Q29kZSI6IlVTRCJ9fX1dfSwibG9jYWxlIjoiZW4iLCJzaG9wIjp7ImlkIjo1MTc0NTA5NTg1NywiZG9tYWluIjoiY29vcC1hcHAtdGVzdC1zdG9yZS5teXNob3BpZnkuY29tIiwibWV0YWZpZWxkcyI6W119LCJ2ZXJzaW9uIjoidW5zdGFibGUifSwiaWF0IjoxNjI3NTkwOTU0fQ.XOxBPlLdGlzMhtY-0CeKvtgyia8apUfzUEHprP9oONs"},"is_dev_shop":true,"is_script_url_override_allowed":true,"thank_you_url":"\/51745095857\/checkouts\/67aba595f2b4c55df0996d6b0c8d8f31\/thank_you?api_key=58b6675f0b26956ef6e548d557c7de15","i18n":{"translations":{"close":"Close","expand":"View more","processing":"Processing…","submit":"Submit","subscription":{"cancelled":"cancelled","agreement":"I understand that I&apos;m agreeing to a subscription. It will renew at the price and frequency listed until it ends or is %{cancelled}.","policy":"Subscription policy"}}},"theme_settings":{"button_color":[245.1104466077334,95.79957468621566,48.42215244691664],"error_color":[12.253337401063547,90.79945969912455,48.71501391351731],"accent_color":[245.1104466077334,95.79957468621566,48.42215244691664],"body_background_color":[19.916405993809086,0.0,100.0],"sidebar_background_color":[18.43494882292201,1.3560741471181056e-10,98.2720236007346],"transparent_input_background_color":false,"body_font_family":"-apple-system, BlinkMacSystemFont, &apos;Segoe UI&apos;, Roboto, Helvetica, Arial, sans-serif, &apos;Apple Color Emoji&apos;, &apos;Segoe UI Emoji&apos;, &apos;Segoe UI Symbol&apos;","body_font_bold":500,"heading_font_family":"-apple-system, BlinkMacSystemFont, &apos;Segoe UI&apos;, Roboto, Helvetica, Arial, sans-serif, &apos;Apple Color Emoji&apos;, &apos;Segoe UI Emoji&apos;, &apos;Segoe UI Symbol&apos;","heading_font_bold":500},"merchant_policies":[]}'`;
export const RENDER_EXTENSION_BASE_FOOTER = `</div></div></body></html>`;

export const RENDER_EXTENSION_PREVIEW = (children) =>
	`${RENDER_EXTENSION_BASE_HEADER}${children}${RENDER_EXTENSION_BASE_FOOTER}`;
